export const interviewQuestionDetails = [
  {
    
    title: "DBMS Interview Questions",
    paragraph:
      "Top DBMS interview questions with answers to help you crack database management system interviews easily and confidently",
    link: "/dbms",
  },
  {
    
    title: "OOPs Interview Questions",
    paragraph:
      "Master top OOPs interview questions and answers to confidently crack object-oriented programming interviews for freshers and experienced candidates.",
    link: "/oops",
  },
  {
    
    title: "Python Interview Questions",
    paragraph:
      "Top Python interview questions and answers to crack technical interviews confidently, covering core Python concepts, coding, and best practices.",
    link: "/python",
  },

  {
  
    title: "Java Interview Questions",
    paragraph:
      "Top Java interview questions and answers covering core Java, OOPs, collections, and multithreading to crack interviews confidently.",
    link: "/java",
  },
  {
    
    title: "C Programming Interview Questions",
    paragraph:
      "Top C programming interview questions and answers to master concepts like pointers, arrays, and memory management for interviews.",
    link: "/c",
  },
  {
 
    title: "C++ Interview Questions",
    paragraph:
      "Top C++ interview questions and answers covering OOPs, inheritance, polymorphism, and STL to crack interviews confidently.",
    link: "/cpp",
  },

  {

    title: "Cloud Computing Interview Questions",
    paragraph:
      "Top cloud computing interview questions and answers covering AWS, Azure, GCP, and cloud fundamentals to crack interviews confidently. ",
    link: "/cloud_computing",
  },
  {
    
    title: "Computer Networking Interview Questions",
    paragraph:
      "Top computer networking interview questions covering OSI model, TCP/IP, routing, and protocols to crack networking interviews easily.",
    link: "/cn",
  },
  {
    
    title: "DataStructure Interview Questions",
    paragraph:
      "Top data structure interview questions covering arrays, linked lists, trees, and algorithms to crack coding interviews confidently.",
    link: "/datastructure",
  },

  {
 
    title: "Operating System Interview Questions",
    paragraph:
      "Top Operating System interview questions covering processes, threads, memory management, and scheduling to crack technical interviews easily.",
    link: "/os",
  },
  {
   
    title: "RDBMS Interview Questions",
    paragraph:
      "Top RDBMS interview questions covering normalization, SQL queries, keys, and transactions to crack database interviews confidently.",
    link: "/rdbms",
  },
  {
    
    title: "Software Development Life Cycle Interview Questions",
    paragraph:
      "Top SDLC interview questions covering phases, models, and methodologies to crack software development and testing interviews easily.",
    link: "/sdlc",
  },
  {
   
    title: "HTML Interview Questions",
    paragraph:
      "Top HTML interview questions covering tags, forms, semantic elements, and best practices to crack web development interviews easily.",
    link: "/html",
  },
  {
   
    title: "JavaScript Interview Questions",
    paragraph:
      "Top JavaScript interview questions covering ES6, DOM, events, closures, and promises to crack frontend and full-stack interviews.",
    link: "/javascript",
  },
  {
    
    title: "REACT Interview Questions",
    paragraph:
      "Top React interview questions covering hooks, components, state management, and lifecycle methods to crack frontend developer interviews easily.",
    link: "/react",
  },

  {
   
    title: "Angular Interview Questions",
    paragraph:
      "Top Angular interview questions covering components, services, directives, and modules to help you crack frontend development interviews easily.",
    link: "/angular",
  },
  {
    
    title: "Android Interview Questions",
    paragraph:
      "Top Android interview questions covering activities, fragments, lifecycle, and architecture to crack mobile app development interviews confidently.",
    link: "/android",
  },
  {

    title: "Bootstrap Coming Soon",
    paragraph:
      "Create stunning Coming Soon pages using Bootstrap with responsive design, countdown timers, and modern layouts for every business.",
    link: "/bootstrap",
  },

  {
    title: "SQL Interview Questions",
    paragraph:
      "Top SQL interview questions covering queries, joins, normalization, and indexing to crack database and backend development interviews easily.",
    link: "/sql",
  },
  {
    
    title: "Testing Interview Questions",
    paragraph:
      "Top Testing interview questions covering manual, automation, Selenium, and QA basics to crack software testing interviews easily.",
    link: "/testing",
  },
];

export const interviewQuestions = [
  {
    question: "1) What is Android?",
    answer:
      "Android is an open-source, Linux-based operating system used in mobiles, tablets, televisions, etc.",
    technology: "android",
  },
  {
    question: "2) Who is the founder of Android?",
    answer: "Andy Rubin.",
    technology: "android",
  },
  {
    question: "3) Explain the Android application Architecture.",
    answer:
      "Following is a list of components of Android application architecture:\n\n1. Services: Used to perform background functionalities.\n2. Intent: Used to perform the interconnection between activities and the data passing mechanism.\n3. Resource Externalization: strings and graphics.\n4. Notification: light, sound, icon, notification, dialog box and toast.\n5. Content Providers: It will share the data between applications.",
    technology: "android",
  },
  {
    question: "4) What are the code names of android?",
    answer:
      "1. Aestro\n2. Blender\n3. Cupcake\n4. Donut\n5. Eclair\n6. Froyo\n7. Gingerbread\n8. Honeycomb\n9. Ice Cream Sandwich\n10. Jelly Bean\n11. KitKat\n12. Lollipop\n13. Marshmallow",
    technology: "android",
  },
  {
    question: "5) What are the advantages of Android?",
    answer:
      "Open-source: It means no license, distribution and development fee.\n\nPlatform-independent: It supports Windows, Mac, and Linux platforms.\n\nSupports various technologies: It supports camera, Bluetooth, wifi, speech, EDGE etc. technologies.\n\nHighly optimized Virtual Machine: Android uses a highly optimized virtual machine for mobile devices, called DVM (Dalvik Virtual Machine).",
    technology: "android",
  },
  {
    question: "6) Does android support other languages than java?",
    answer:
      "Yes, an android app can be developed in C/C++ also using android NDK (Native Development Kit). It makes the performance faster. It should be used with Android SDK.",
    technology: "android",
  },
  {
    question: "7) What are the core building blocks of android?",
    answer:
      "The core building blocks of Android are:\n\n1. Activity\n2. View\n3. Intent\n4. Service\n5. Content Provider\n6. Fragment etc.",
    technology: "android",
  },
  {
    question: "8) What is activity in Android?",
    answer:
      "Activity is like a frame or window in java that represents GUI. It represents one screen of android.",
    technology: "android",
  },
  {
    question: "9) How are view elements identified in the android program?",
    answer: "View elements can be identified using the keyword findViewById.",
    technology: "android",
  },
  {
    question: "10) What is intent?",
    answer:
      "It is a kind of message or information that is passed to the components. It is used to launch an activity, display a web page, send SMS, send email, etc. There are two types of intents in android:\n\n1. Implicit Intent\n2. Explicit Intent",
    technology: "android",
  },
  {
    question: "1) What is AngularJS?",
    answer:
      "AngularJS is a javascript framework used for creating single web page applications. It allows you to use HTML as your template language and enables you to extend HTML’s syntax to express your application’s components clearly",
    technology: "angular",
  },
  {
    question: "2) Explain what are the key features of AngularJS ?",
    answer:
      "The key features of AngularJS are\n\nScope\nController\nModel\nView\nServices\nData Binding\nDirectives\nFilters\nTestable",
    technology: "angular",
  },
  {
    question: "3) Explain what is scope in AngularJS ?",
    answer:
      "Scope refers to the application model, it acts like glue between application controller and the view. Scopes are arranged in hierarchical structure and impersonate the DOM (Document Object Model) structure of the application. It can watch expressions and propagate events.",
    technology: "angular",
  },
  {
    question: "4) Explain what is services in AngularJS ?",
    answer:
      "In AngularJS services are the singleton objects or functions that are used for carrying out specific tasks. It holds some business logic and these function can be called as controllers, directive, filters and so on.",
    technology: "angular",
  },
  {
    question:
      "5) Explain what is Angular Expression? Explain what is key difference between angular expressions and JavaScript expressions?",
    answer:
      "Like JavaScript, Angular expressions are code snippets that are usually placed in binding such as {{ expression }}\n\nThe key difference between the JavaScript expressions and Angular expressions\n\n1. Context : In Angular, the expressions are evaluated against a scope object, while the Javascript expressions are evaluated against the global window\n2. Forgiving: In Angular expression evaluation is forgiving to null and undefined, while in Javascript undefined properties generates TypeError or ReferenceError\n3. No Control Flow Statements: Loops, conditionals or exceptions cannot be used in an angular expression\n4. Filters: To format data before displaying it you can use filters",
    technology: "angular",
  },
  {
    question:
      "6) With options on page load how you can initialize a select box ?",
    answer:
      'You can initialize a select box with options on page load by using ng-init directive\n\n<div ng-controller = " apps/dashboard/account " ng-switch On = "! ! accounts" ng-init = " loadData ( ) ">',
    technology: "angular",
  },
  {
    question:
      "7) Explain what are directives ? Mention some of the most commonly used directives in AngularJS application ?",
    answer:
      "A directive is something that introduces new syntax, they are like markers on DOM element which attaches a special behavior to it. In any AngularJS application, directives are the most important components.\n\nSome of the commonly used directives are ng-model, ng-App, ng-bind, ng-repeat , ng-show etc.",
    technology: "angular",
  },
  {
    question: "8) Mention what are the advantages of using AngularJS ?",
    answer:
      "AngularJS has several advantages in web development.\n\nAngularJS supports MVC pattern\nCan do two ways data binding using AngularJS\nIt has per-defined form validations\nIt supports both client server communication\nIt supports animations",
    technology: "angular",
  },
  {
    question: "9) Explain what Angular JS routes does ?",
    answer:
      "Angular js routes enable you to create different URLs for different content in your application. Different URLs for different content enables user to bookmark URLs to specific content. Each such bookmarkable URL in AngularJS is called a route\n\nA value in Angular JS is a simple object. It can be a number, string or JavaScript object. Values are typically used as configuration injected into factories, services or controllers. A value should be belong to an AngularJS module.\n\nInjecting a value into an AngularJS controller function is done by adding a parameter with the same name as the value",
    technology: "angular",
  },
  {
    question: "10) Explain what is data binding in AngularJS ?",
    answer:
      "Automatic synchronization of data between the model and view components is referred as data binding in AngularJS. There are two ways for data binding\n\n1. Data mining in classical template systems\n2. Data binding in angular templates",
    technology: "angular",
  },
  {
    question: "Q #1) Define Bootstrap.",
    answer:
      "Answer: Bootstrap is a front-end framework that is used for creating HTML, CSS, and JS web applications. Its layout is very responsive, fast and easy to use. It mostly focuses on building a mobile application with having design templates for creating UI like Dropdown, Forms, Buttons, Alerts Tab, etc.",
    technology: "bootstrap",
  },
  {
    question: "Q #2) Why Bootstrap is used for Mobile Web development?",
    answer:
      "Answer: It is used for Mobile Web development because it has responsive designs and templates which are easy to use.",
    technology: "bootstrap",
  },
  {
    question: "Q #3) Explain the features of Bootstrap.",
    answer:
      "Answer: Its features include:\n\nOpen source for use\nCompatibility with all browsers.\nResponsive designs\nEasy to use and fast.",
    technology: "bootstrap",
  },
  {
    question: "Q #4) Define the key components of Bootstrap.",
    answer:
      "Answer: Its components include:\n\n1. Scaffolding: It has the grid system, background, styles.\n2. JS Plugins: Contains JS and jQuery plugins.\n3. Customize: Can customize frameworks.\n4. CSS: Contains CSS files.",
    technology: "bootstrap",
  },
  {
    question: "Q #5) What do you understand by Bootstrap container?",
    answer:
      "Answer: Bootstrap container behaves like a container where you can put HTML code and it is a part within the page where the content of the site can be placed to make it responsive and fast.",
    technology: "bootstrap",
  },
  {
    question: "Q #6) What do you mean by Bootstrap Classloader?",
    answer:
      "Answer: Bootstrap class loader is a part of java and a main parental class of class loader.",
    technology: "bootstrap",
  },
  {
    question: "Q #7) How many types of layouts are there in Bootstrap?",
    answer:
      "Answer: There are two types of layouts in Bootstrap.\nThey are:\n\n1. Fluid Layout\n2. Fixed Layout",
    technology: "bootstrap",
  },
  {
    question: "Q #8) Define Fluid Layout.",
    answer:
      "Answer: Fluid Layout is useful when you need to make an app that involves the full width of the screen i.e. Fluid Layout adjusts itself according to the browser size.",
    technology: "bootstrap",
  },
  {
    question: "Q #9) Define Fixed Layout.",
    answer:
      "Answer: A fixed layout is responsive and easy to use but just like the fluid layout, it cannot adjust itself according to the browser size. The fixed layout should be 940 px in most cases.",
    technology: "bootstrap",
  },
  {
    question: "10) What is intent?",
    answer:
      "It is a kind of message or information that is passed to the components. It is used to launch an activity, display a web page, send SMS, send email, etc. There are two types of intents in android:\n\n1. Implicit Intent\n2. Explicit Intent",
    technology: "bootstrap",
  },
  {
    question: "Q #1) What is the basic structure of a C++ program?",
    answer:
      "The basic structure of a C++ program is shown below:\n\n#include<iostream.h>\nint main()\n{\ncout<<”Hello,World!”;\nreturn 0;\n}\nThe first line",
    technology: "cpp",
  },
  {
    question: "Q #2) What are the Comments in C++?",
    answer:
      "Comments in C++ are simply a piece of source code ignored by the compiler. They are only helpful for a programmer to add a description or additional information about their source code.\n\nIn C++ there are two ways to add comments:\n\n//single-line comment\n/* block comment */\nThe first type will discard everything after the compiler encounters “//”. In the second type, the compiler discards everything between “/*” and “*/”.",
    technology: "cpp",
  },
  {
    question:
      "Q #3) Difference between Declaration and Definition of a variable.",
    answer:
      "Answer: The declaration of a variable is merely specifying the data type of a variable and the variable name. As a result of the declaration, we tell the compiler to reserve the space for a variable in the memory according to the data type specified.\n\nExample:\n\nint Result;\nchar c;\nint a,b,c;\nAll the above are valid declarations. Also, note that as a result of the declaration, the value of the variable is undetermined.\n\nWhereas, a definition is an implementation/instantiation of the declared variable where we tie up appropriate value to the declared variable so that the linker will be able to link references to the appropriate entities.\n\nFrom above Example,\n\nResult = 10;\nC = ‘A’;\nThese are valid definitions.",
    technology: "cpp",
  },
  {
    question: "Q #4) Comment on Local and Global scope of a variable.",
    answer:
      "Answer: The scope of a variable is defined as the extent of the program code within which the variable remains active i.e. it can be declared, defined or worked with.\n\nThere are two types of scope in C++:\n\nLocal Scope: A variable is said to have a local scope or is local when it is declared inside a code block. The variable remains active only inside the block and is not accessible outside the code block.\nGlobal Scope: A variable has a global scope when it is accessible throughout the program. A global variable is declared on top of the program before all the function definitions.\nExample:\n\n#include <iostream.h>\nInt globalResult=0; //global variable\nint main()\n{\nInt localVar = 10; //local variable.\n….. \n}",
    technology: "cpp",
  },
  {
    question:
      "Q #5) What is the precedence when there are a Global variable and a Local variable in the program with the same name?",
    answer:
      "Answer: Whenever there is a local variable with the same name as that of a global variable, the compiler gives precedence to the local variable.\n\nExample:\n\n#include <iostream.h>\nint globalVar = 2;\nint main()\n{\nint globalVar = 5;\ncout<<globalVar<<endl;\n}\nThe output of the above code is 5. This is because, although both the variables have the same name, the compiler has given preference to the local scope.",
    technology: "cpp",
  },
  {
    question:
      "Q #6) When there are a Global variable and Local variable with the same name, how will you access the global variable?",
    answer:
      "Answer: When there are two variables with the same name but different scope, i.e. one is a local variable and the other is a global variable, the compiler will give preference to a local variable.\n\nIn order to access the global variable, we make use of a “scope resolution operator (::)”. Using this operator, we can access the value of the global variable.\n\nExample:\n\n#include<iostream.h>\nint x= 10;\nint main()\n{\nint x= 2;\ncout<<”Global Variable x = “<<::x;\ncout<<”/nlocal Variable x= “<<x;\n}\nOutput:\n\nGlobal Variable x = 10\nlocal Variable x= 2",
    technology: "cpp",
  },
  {
    question:
      "Q #7) How many ways are there to initialize an int with a Constant?",
    answer:
      "Answer: There are two ways:\n\nThe first format uses traditional C notation.\nint result = 10;\nThe second format uses the constructor notation.\nint result (10);",
    technology: "cpp",
  },
  {
    question: "Q #8) What is a Constant? Explain with an example.",
    answer:
      "Answer: A constant is an expression that has a fixed value. They can be divided into integer, decimal, floating-point, character or string constants depending on their data type.\n\nApart from the decimal, C++ also supports two more constants i.e. octal (to the base 8) and hexadecimal (to the base 16) constants.\n\nExamples of Constants:\n\n75 //integer (decimal)\n0113 //octal\n0x4b //hexadecimal\n3.142 //floating point\n‘c’ //character constant\n“Hello, World” //string constant\nNote: When we have to represent a single character, we use single quotes and when we want to define a constant with more than one character, we use double-quotes.",
    technology: "cpp",
  },
  {
    question: "Q #9) How do you define/declare constants in C++?",
    answer:
      "Answer: In C++, we can define our own constants using the #define preprocessor directive.\n\n#define Identifier value\n\nExample:\n\n#include<iostream.h>\n#define PI 3.142\nint main ()\n{\nfloat radius =5, area;\narea = PI * r * r;\ncout<<”Area of a Circle = “<<area;\n}\nOutput: Area of a Circle = 78.55\n\nAs shown in the above example, once we define a constant using #define directive, we can use it throughout the program and substitute its value.\n\nWe can declare constants in C++ using the “const” keyword. This way is similar to that of declaring a variable, but with a const prefix.\n\nExamples of declaring a constant\n\nconst int pi = 3.142;\nconst char c = “sth”;\nconst zipcode = 411014;\n\nIn the above examples, whenever the type of a constant is not specified, the C++ compiler defaults it to an integer type.",
    technology: "cpp",
  },
  {
    question: "Q #10) Comment on Assignment Operator in C++.",
    answer:
      "Answer: Assignment operator in C++ is used to assign a value to another variable.\n\na = 5;\n\nThis line of code assigns the integer value 5 to variable a.\n\nThe part at the left of the =operator is known as an lvalue (left value) and the right as rvalue (right value). Lvalue must always be a variable whereas the right side can be a constant, a variable, the result of an operation or any combination of them.\n\nThe assignment operation always takes place from the right to left and never at the inverse.\n\nOne property which C++ has over the other programming languages is that the assignment operator can be used as the rvalue (or part of an rvalue) for another assignment.\n\nExample:\n\na = 2 + (b = 5);\n\nis equivalent to:\n\nb = 5;\na = 2 + b;\n\nWhich means, first assign 5 to variable b and then assign to a, the value 2 plus the result of the previous expression of b(that is 5), leaves a with a final value of 7.\n\nThus, the following expression is also valid in C++:\n\na = b = c = 5;\n\nassign 5 to variables a, b and c.",
    technology: "cpp",
  },
  {
    question: "Q #1) What are the key features in the C programming language?",
    answer:
      "Features are as follows:\n\nPortability: It is a platform-independent language.\nModularity: Possibility to break down large programs into small modules.\nFlexibility: The possibility of a programmer to control the language.\nSpeed: C comes with support for system programming and hence it compiles and executes with high speed when compared with other high-level languages.\nExtensibility: Possibility to add new features by the programmer.",
    technology: "c",
  },
  {
    question: "Q #2) What are the basic data types associated with C?",
    answer:
      "Int – Represent the number (integer)\nFloat – Number with a fraction part.\nDouble – Double-precision floating-point value\nChar – Single character\nVoid – Special purpose type without any value.",
    technology: "c",
  },
  {
    question: "Q #3) What is the description for syntax errors?",
    answer:
      "Answer: The mistakes/errors that occur while creating a program are called syntax errors. Misspelled commands or incorrect case commands, an incorrect number of parameters in calling method /function, data type mismatches can be identified as common examples for syntax errors.",
    technology: "c",
  },
  {
    question:
      "Q #4) What is the process to create increment and decrement statement in C?",
    answer:
      "There are two possible methods to perform this task.\n\nUse increment (++) and decrement (-) operator.\nExample When x=4, x++ returns 5 and x- returns 3.\n\nUse conventional + or – sign.\nExample When x=4, use x+1 to get 5 and x-1 to get 3.",
    technology: "c",
  },
  {
    question: "Q #5) What are reserved words with a programming language?",
    answer:
      "The words that are a part of the standard C language library are called reserved words. Those reserved words have special meaning and it is not possible to use them for any activity other than its intended functionality.\n\nExample: void, return int.",
    technology: "c",
  },
  {
    question: "Q #6) What is the explanation for the dangling pointer in C?",
    answer:
      "When there is a pointer pointing to a memory address of any variable, but after some time the variable was deleted from the memory location while keeping the pointer pointing to that location is known as a dangling pointer in C.",
    technology: "c",
  },
  {
    question: "Q #7) Describe static function with its usage?",
    answer:
      "Answer: A function, which has a function definition prefixed with a static keyword is defined as a static function. The static function should be called within the same source code.",
    technology: "c",
  },
  {
    question:
      "Q #8) What is the difference between abs() and fabs() functions?",
    answer:
      "Answer: Both functions are to retrieve absolute value. abs() is for integer values and fabs() is for floating type numbers. Prototype for abs() is under the library file < stdlib.h > and fabs() is under < math.h >.",
    technology: "c",
  },
  {
    question: "Q #9) Describe Wild Pointers in C?",
    answer:
      "Answer: Uninitialized pointers in the C code are known as Wild Pointers. They point to some arbitrary memory location and can cause bad program behavior or program crash.",
    technology: "c",
  },
  {
    question: "Q #10) What is the difference between ++a and a++?",
    answer:
      "Answer: ‘++a”  is called prefixed increment and the increment will happen first on a variable. ‘a++' is called postfix increment and the increment happens after the value of a variable used for the operations.",
    technology: "c",
  },
  {
    question: "1) What is cloud computing?",
    answer:
      "Cloud computing is an internet based new age computer technology. It is the next stage technology that uses the clouds to provide the services whenever and wherever the user need it. It provides a method to access several servers worldwide.",
    technology: "cloud_computing",
  },
  {
    question: "2) What are the benefits of cloud computing?",
    answer:
      "The main benefits of cloud computing are:\n\n- Data backup and storage of data.\n- Powerful server capabilities.\n- Incremented productivity.\n- Very cost effective and time saving.\n- Software as Service known as SaaS.",
    technology: "cloud_computing",
  },
  {
    question: "3) What is a cloud?",
    answer:
      "A cloud is a combination of networks, hardware, services, storage, and interfaces that helps in delivering computing as a service. It has three users:\n\n- End users\n- Business management users\n- Cloud service provider",
    technology: "cloud_computing",
  },
  {
    question: "4) What are the different data types used in cloud computing?",
    answer:
      "There are different data types in cloud computing like emails, contracts, images, blogs, etc. As we know that data is increasing day by day so it is needed to create new data types to store these new types of data. For example, if you want to store video, then you need a new data type.",
    technology: "cloud_computing",
  },
  {
    question:
      "5) Which are the different layers that define cloud architecture?",
    answer:
      "Following are the different layers that are used by cloud architecture:\n\n- CLC or Cloud Controller\n- Walrus\n- Cluster Controller\n- SC or Storage Controller\n- NC or Node Controller",
    technology: "cloud_computing",
  },
  {
    question: "6) Which platforms are used for large scale cloud computing?",
    answer:
      "The following platforms are used for large scale cloud computing:\n\n- Apache Hadoop\n- MapReduce",
    technology: "cloud_computing",
  },
  {
    question:
      "7) What are the different layers in cloud computing? Explain working of them.",
    answer:
      "There are 3 layers in the hierarchy of cloud computing:\n\n- Infrastructure as a Service (IaaS): It provides cloud infrastructure in terms of hardware such as memory, processor, speed, etc.\n- Platform as a Service (PaaS): It provides cloud application platforms for the developer.\n- Software as a Service (SaaS): It provides cloud applications to users directly without installing anything on the system. These applications remain on the cloud.",
    technology: "cloud_computing",
  },
  {
    question: "8) What do you mean by software as a service?",
    answer:
      "Software As a Service (SaaS) is an important layer of cloud computing. It provides cloud applications like Google does. It facilitates users to save their documents on the cloud and create them as well.",
    technology: "cloud_computing",
  },
  {
    question: "9) What is the platform as a service?",
    answer:
      "It is also a layer in cloud architecture. This model is built on the infrastructure model and provides resources like computers, storage, and network. It is responsible for providing complete virtualization of the infrastructure layer, making it look like a single server and invisible to the outside world.",
    technology: "cloud_computing",
  },
  {
    question:
      "10) What is on-demand functionality? How is it provided in cloud computing?",
    answer:
      "Cloud computing provides on-demand access to virtualized IT resources. It can be used by the subscriber. It uses a shared pool to provide configurable resources. The shared pool contains networks, servers, storage, applications, and services.",
    technology: "cloud_computing",
  },
  {
    question: "Q #1) What is a Network?",
    answer:
      "Answer: Network is defined as a set of devices connected to each other using a physical transmission medium.\n\nFor Example, A computer network is a group of computers connected with each other to communicate and share information and resources like hardware, data, and software. In a network, nodes are used to connect two or more networks.",
    technology: "cn",
  },
  {
    question: "Q #2) What is a Node?",
    answer:
      "Answer: Two or more computers are connected directly by an optical fiber or any other cable. A node is a point where a connection is established. It is a network component that is used to send, receive and forward the electronic information.\n\nA device connected to a network is also termed as Node. Let's consider that in a network there are 2 computers, 2 printers, and a server are connected, then we can say that there are five nodes on the network.",
    technology: "cn",
  },
  {
    question: "Q #3) What is Network Topology?",
    answer:
      "Answer: Network topology is a physical layout of the computer network and it defines how the computers, devices, cables, etc are connected to each other.",
    technology: "cn",
  },
  {
    question: "Q #4) What are Routers?",
    answer:
      "Answer: The router is a network device that connects two or more network segments. It is used to transfer information from the source to the destination.\n\nRouters send the information in terms of data packets and when these data packets are forwarded from one router to another router then the router reads the network address in the packets and identifies the destination network.",
    technology: "cn",
  },
  {
    question: "Q #5) What is the OSI reference model?",
    answer:
      "Answer: Open System Interconnection, the name itself suggests that it is a reference model that defines how applications can communicate with each other over a networking system.\n\nIt also helps to understand the relationship between networks and defines the process of communication in a network.",
    technology: "cn",
  },
  {
    question:
      "Q #6) What are the layers in OSI Reference Models? Describe each layer briefly.",
    answer:
      "Answer: Given below are the seven layers of OSI Reference Models:\n\n a) Physical Layer (Layer 1): It converts data bits into electrical impulses or radio signals. Example: Ethernet.\n\n b) Data Link Layer (Layer 2): At the Data Link layer, data packets are encoded and decoded into bits and it provides a node to node data transfer. This layer also detects the errors that occurred at Layer 1.\n\n c) Network Layer (Layer 3): This layer transfers variable length data sequence from one node to another node in the same network. This variable-length data sequence is also known as “Datagrams”.\n\n d) Transport Layer (Layer 4): It transfers data between nodes and also provides acknowledgment of successful data transmission. It keeps track of transmission and sends the segments again if the transmission fails.\n\n e) Session Layer (Layer 5): This layer manages and controls the connections between computers. It establishes, coordinates, exchange and terminates the connections between local and remote applications.\n\n f) Presentation Layer (Layer 6): It is also called as “Syntax Layer”. Layer 6 transforms the data into the form in which the application layer accepts.\n\n g) Application Layer (Layer 7): This is the last layer of the OSI Reference Model and is the one that is close to the end-user. Both end-user and application layer interacts with the software application. This layer provides services for email, file transfer, etc.",
    technology: "cn",
  },
  {
    question: "Q #7) What is the difference between Hub, Switch, and Router?",
    answer:
      "Answer:\n\n Hub :- Hub is least expensive, least intelligent and least complicated of the three. It broadcast all data to every port which may cause serious security and reliability concern. In a Network, Hub is a common connection point for devices connected to the network. Hub contains multiple ports and is used to connect segments of LAN.\n\n Switch :- Switches work similarly like Hubs but in a more efficient manner. It creates connections dynamically and provides information only to the requesting port. Switch is a device in a network which forwards packets in a network.\n\n Router:- The router is smartest and most complicated out of these three. It comes in all shapes and sizes. Routers are similar like little computers dedicated for routing network traffic. Routers are located at gateway and forwards data packets",
    technology: "cn",
  },
  {
    question: "Q #8) Explain TCP/IP Model",
    answer:
      "Answer: The most widely used and available protocol is TCP/IP i.e. Transmission Control Protocol and Internet Protocol. TCP/IP specifies how data should be packaged, transmitted and routed in their end to end data communication.\n\nGiven below is a brief explanation of each layer:\n\n Application Layer: This is the top layer in the TCP/IP model. It includes processes that use the Transport Layer Protocol to transmit the data to their destination. There are different Application Layer Protocols such as HTTP, FTP, SMTP, SNMP protocols, etc.\n\n Transport Layer: It receives the data from the Application Layer which is above the Transport Layer. It acts as a backbone between the host's system connected with each other and it mainly concerns about the transmission of data. TCP and UDP are mainly used as Transport Layer protocols.\n\n Network or Internet Layer: This layer sends the packets across the network. Packets mainly contain source & destination IP addresses and actual data to be transmitted.\n\n Network Interface Layer: It is the lowest layer of the TCP/IP model. It transfers the packets between different hosts. It includes encapsulation of IP packets into frames, mapping IP addresses to physical hardware devices, etc.",
    technology: "cn",
  },
  {
    question: "Q #9) What is HTTP and what port does it use?",
    answer:
      "Answer: HTTP is HyperText Transfer Protocol and it is responsible for web content. Many web pages are using HTTP to transmit the web content and allow the display and navigation of HyperText. It is the primary protocol and port used here is TCP port 80.",
    technology: "cn",
  },
  {
    question: "Q #10) What is HTTPs and what port does it use?",
    answer:
      "Answer: HTTPs is a Secure HTTP. HTTPs is used for secure communication over a computer network. HTTPs provides authentication of websites that prevents unwanted attacks.\nIn bi-directional communication, the HTTPs protocol encrypts the communication so that the tampering of the data gets avoided. With the help of an SSL certificate, it verifies if the requested server connection is a valid connection or not. HTTPs use TCP with port 443.",
    technology: "cn",
  },
  {
    question: "1) What is Data Structure? Explain.",
    answer:
      "The data structure is a way that specifies how to organize and manipulate the data. It also defines the relationship between them. Some examples of Data Structures are arrays, Linked List, Stack, Queue, etc. Data Structures are the central part of many computer science algorithms as they enable the programmers to handle the data in an efficient way.",
    technology: "datastructure",
  },
  {
    question: "2) Describe the types of Data Structures?",
    answer:
      "Data Structures are mainly classified into two types:\n\nLinear Data Structure: A data structure is called linear if all of its elements are arranged in the sequential order. In linear data structures, the elements are stored in a non-hierarchical way where each item has the successors and predecessors except the first and last element.\n\nNon-Linear Data Structure: The Non-linear data structure does not form a sequence i.e. each item or element is connected with two or more other items in a non-linear arrangement. The data elements are not arranged in the sequential structure.",
    technology: "datastructure",
  },
  {
    question: "3) List the area of applications of Data Structure.",
    answer:
      "Data structures are applied extensively in the following areas of computer science:\n\n- Compiler Design\n- Operating System\n- Database Management System\n- Statistical analysis package\n- Numerical Analysis\n- Graphics\n- Artificial Intelligence\n- Simulation",
    technology: "datastructure",
  },
  {
    question:
      "4) What is the difference between file structure and storage structure?",
    answer:
      "Difference between file structure and storage structure:\n\nThe main difference between file structure and storage structure is based on memory area that is being accessed.\n\nStorage structure: It is the representation of the data structure in the computer memory.\n\nFile structure: It is the representation of the storage structure in the auxiliary memory.",
    technology: "datastructure",
  },
  {
    question:
      "5) List the data structures which are used in RDBMS, Network Data Model, and Hierarchical Data Model.",
    answer:
      "RDBMS uses Array data structure\nNetwork data model uses Graph\nHierarchical data model uses Trees",
    technology: "datastructure",
  },
  {
    question: "6) What are the operations that can be performed on a stack?",
    answer: "Push Operations\nPop Operations\nPeek Operations",
    technology: "datastructure",
  },
  {
    question: "7) Write the stack overflow condition.",
    answer: "Overflow occurs when top = Maxsize -1",
    technology: "datastructure",
  },
  {
    question: "8) What is the difference between PUSH and POP?",
    answer:
      "PUSH and POP operations specify how data is stored and retrieved in a stack.\n\nPUSH: PUSH specifies that data is being 'inserted' into the stack.\n\nPOP: POP specifies data retrieval. It means that data is being deleted from the stack.",
    technology: "datastructure",
  },
  {
    question:
      "9) Write the steps involved in the insertion and deletion of an element in the stack.",
    answer:
      "Push:\n\n- Increment the variable top so that it can refer to the next memory allocation\n- Copy the item to the at the array index value equal to the top\n- Repeat step 1 and 2 until stack overflows\n\nPop:\n\n- Store the topmost element into the another variable\n- Decrement the value of the top\n- Return the topmost element",
    technology: "datastructure",
  },
  {
    question: "10) What is a postfix expression?",
    answer:
      "An expression in which operators follow the operands is known as postfix expression. The main benefit of this form is that there is no need to group sub-expressions in parentheses or to consider operator precedence.\nThe expression 'a + b' will be represented as 'ab+' in postfix notation.",
    technology: "datastructure",
  },

  {
    question: "Q1) What is DBMS used for?",
    answer:
      "DBMS, commonly known as Database Management System, is an application system whose main purpose revolves around the data. This is a system that allows its user to store the data, define it, retrieve it and update the information about the data inside the database.",
    technology: "dbms",
  },
  {
    question: "Q2) What is meant by a Database?",
    answer:
      "In simple terms, Database is a collection of data in some organized way to facilitate its user’s to easily access, manage and upload the data.",
    technology: "dbms",
  },
  {
    question: "Q3) What is the purpose of normalization in DBMS?",
    answer:
      "Normalization is the process of analyzing the relational schemas which are based on their respective functional dependencies and the primary keys in order to fulfill certain properties. The properties include:\n1. To minimize the redundancy of the data.\n2. To minimize the Insert, Delete and Update Anomalies.",
    technology: "dbms",
  },
  {
    question: "Q4) What is the purpose of SQL?",
    answer:
      "SQL stands for Structured Query Language whose main purpose is to interact with the relational databases in the form of inserting and updating/modifying the data in the database.",
    technology: "dbms",
  },
  {
    question: "Q5) Explain the concepts of a Primary key and Foreign Key.",
    answer:
      "Primary Key is used to uniquely identify the records in a database table while Foreign Key is mainly used to link two or more tables together, as this is a particular field(s) in one of the database tables which are the primary key of some other table. Example: There are 2 tables – Employee and Department. Both have one common field/column as ‘ID’ where ID is the primary key of the Employee table while this is the foreign key for the Department table.",
    technology: "dbms",
  },
  {
    question:
      "Q6) What are the main differences between Primary key and Unique Key?",
    answer:
      "Given below are few differences:\n1. The main difference between the Primary key and Unique key is that the Primary key can never have a null value while the Unique key may consist of null value.\n2. In each table, there can be only one primary key while there can be more than one unique key in a table.",
    technology: "dbms",
  },
  {
    question: "Q7) What is the concept of sub-query in terms of SQL?",
    answer:
      "Sub-query is basically the query which is included inside some other query and can also be called as an inner query which is found inside the outer query.",
    technology: "dbms",
  },
  {
    question:
      "Q8) What is the use of DROP command and what are the differences between DROP, TRUNCATE and DELETE commands?",
    answer:
      "DROP command is a DDL command which is used to drop/delete the existing table, database, index or view from the database. The major difference between DROP, TRUNCATE and DELETE commands are:\nDROP and TRUNCATE commands are the DDL commands which are used to delete tables from the database and once the table gets deleted, all the privileges and indexes that are related to the table also get deleted. These 2 operations cannot be rolled back and so should be used only when necessary.\nDELETE command, on the other hand, is a DML Command which is also used to delete rows from the table and this can be rolled back.\nNote: It is recommended to use the ‘WHERE’ clause along with the DELETE command else the complete table will get deleted from the database.",
    technology: "dbms",
  },
  {
    question: "Q9) What is the main difference between UNION and UNION ALL?",
    answer:
      "UNION and UNION ALL are used to join the data from 2 or more tables but UNION removes duplicate rows and picks the rows which are distinct after combining the data from the tables whereas UNION ALL does not remove the duplicate rows, it just picks all the data from the tables.",
    technology: "dbms",
  },
  {
    question: "Q10) What is Correlated Subquery in DBMS?",
    answer:
      "A Subquery is also known as a nested query i.e. a query written inside some query. When a Subquery is executed for each of the rows of the outer query then it is termed as a Correlated Subquery.\nExample of Non-Correlated Subquery is:\nSELECT * from EMP WHERE ‘RIYA’ IN (SELECT Name from DEPT WHERE EMP.EMPID=DEPT.EMPID);\nHere, the inner query is not executed for each of the rows of the outer query.",
    technology: "dbms",
  },
  {
    question: "Q11) Explain Entity, Entity Type, and Entity Set in DBMS?",
    answer:
      "Entity is an object, place or thing which has its independent existence in the real world and about which data can be stored in a database. For Example, any person, book, etc.\nEntity Type is a collection of entities that have the same attributes. For Example, the STUDENT table contains rows in which each row is an entity holding the attributes like name, age, and id of the students, hence STUDENT is an Entity Type which holds the entities having the same attributes.\nEntity Set is a collection of entities of the same type. For Example, A collection of the employees of a firm.",
    technology: "dbms",
  },
  {
    question: "Q12) What are the different levels of abstraction in the DBMS?",
    answer:
      "There are 3 levels of data abstraction in the DBMS. They include:\nPhysical Level: This is the lowest level of the data abstraction which states how the data is stored in the database.\nLogical Level: This is the next level of the data abstraction which states the type of the data and the relationship among the data that is stored in the database.\nView Level: This is the highest level in the data abstraction which shows/states only a part of the database.",
    technology: "dbms",
  },
  {
    question: "Q13) What integrity rules exist in the DBMS?",
    answer:
      "There are 2 major integrity rules that exist in the DBMS. They are:\nEntity Integrity: This states a very important rule that value of a Primary key can never have a NULL value.\nReferential Integrity: This rule is related to the Foreign key which states that either the value of a Foreign key is a NULL value or it should be the primary key of any other relation.",
    technology: "dbms",
  },
  {
    question: "Q14) What is E-R model in the DBMS?",
    answer:
      "E-R model is known as an Entity-Relationship model in the DBMS which is based on the concept of the Entities and the relationship that exists among these entities.",
    technology: "dbms",
  },
  {
    question: "Q15) What is a functional dependency in the DBMS?",
    answer:
      "This is basically a constraint which is useful in describing the relationship among the different attributes in a relation.\nExample: If there is some relation ‘R1’ which has 2 attributes as Y and Z then the functional dependency among these 2 attributes can be shown as Y->Z which states that Z is functionally dependent on Y.",
    technology: "dbms",
  },
  {
    question: "1) What is HTML?",
    answer:
      "HTML stands for Hyper Text Markup Language. It is a language of World Wide Web. It is a standard text formatting language which is used to create and display pages on the Web. It makes the text more interactive and dynamic. It can turn text into images, tables, links",
    technology: "html",
  },
  {
    question: "2) What are Tags?",
    answer:
      "HTML tags are composed of three things: an opening tag, content and ending tag. Some tags are unclosed tags.\n\nHTML documents contain two things:\ncontent, and\ntags\nWhen a web browser reads an HTML document, the browser reads it from top to bottom and left to right. HTML tags are used to create HTML documents and render their properties. Each HTML tag has different properties.\n\nSyntax:\n<tag> content </tag>\nContent is placed between tags to display data on the web page.",
    technology: "html",
  },
  {
    question: "3) Do all HTML tags have an end tag?",
    answer:
      "No. There are some HTML tags that don't need a closing tag. For example: <image> tag, <br> tag. More details.",
    technology: "html",
  },
  {
    question: "4) What is formatting in HTML?",
    answer:
      "The HTML formatting is a process of formatting the text for a better look and feel. It uses different tags to make text bold, italicized, underlined.",
    technology: "html",
  },
  {
    question: "5) How many types of heading does an HTML contain?",
    answer:
      "The HTML contains six types of headings which are defined with the <h1> to <h6> tags. Each type of heading tag displays different text size from another. So, <h1> is the largest heading tag and <h6> is the smallest one.",
    technology: "html",
  },
  {
    question: "6) How to create a hyperlink in HTML?",
    answer:
      "The HTML provides an anchor tag to create a hyperlink that links one page to another page. These tags can appear in any of the following ways:\n\nUnvisited link - It is displayed, underlined and blue.\nVisited link - It is displayed, underlined and purple.\nActive link - It is displayed, underlined and red.",
    technology: "html",
  },
  {
    question:
      "7) Which HTML tag is used to display the data in the tabular form?",
    answer:
      "The HTML table tag is used to display data in tabular form (row * column). It also manages the layout of the page, e.g., header section, navigation bar, body content, footer section.",
    technology: "html",
  },
  {
    question:
      "8) What are some common lists that are used when designing a page?",
    answer:
      "There are many common lists which are used to design a page. You can choose any or a combination of the following list types:\n\nOrdered list - The ordered list displays elements in numbered format. It is represented by <ol> tag.\nUnordered list - The unordered list displays elements in bulleted format. It is represented by <ul> tag.\nDefinition list - The definition list displays elements in definition form like in a dictionary. The <dl>, <dt> and <dd> tags are used to define the description list.",
    technology: "html",
  },
  {
    question: "9) What is the difference between HTML elements and tags?",
    answer:
      "HTML elements communicate to the browser to render text. When the elements are enclosed by brackets <>, they form HTML tags. Most of the time, tags come in a pair and surround content.",
    technology: "html",
  },
  {
    question: "10) What is semantic HTML?",
    answer:
      "Semantic HTML is a coding style. It is the use of HTML markup to reinforce the semantics or meaning of the content. For example: In semantic HTML <b> </b> tag is not used for a bold statement as well as <i> </i> tag is used for italic. Instead of these, we use <strong></strong> and <em></em> tags.",
    technology: "html",
  },
  {
    question: "Q1. What are wrapper classes in Java?",
    answer:
      "Wrapper classes convert the Java primitives into the reference types (objects). Every primitive data type has a class dedicated to it. These are known as wrapper classes because they “wrap” the primitive data type into an object of that class. Refer to the below image which displays different primitive type, wrapper class and constructor argument.",
    technology: "java",
  },
  {
    question: "Q2. What are constructors in Java?",
    answer:
      "In Java, constructor refers to a block of code which is used to initialize an object. It must have the same name as that of the class. Also, it has no return type and it is automatically called when an object is created.",
    technology: "java",
  },
  {
    question:
      "Q3. What is singleton class in Java and how can we make a class singleton?",
    answer:
      "Singleton class is a class whose only one instance can be created at any given time, in one JVM. A class can be made singleton by making its constructor private.",
    technology: "java",
  },
  {
    question: "Q4. What is the difference between equals() and == in Java?",
    answer:
      "Equals() method is defined in Object class in Java and used for checking equality of two objects defined by business logic. ‘==’ or equality operator in Java is a binary operator provided by Java programming language and used to compare primitives and objects. public boolean equals(Object o) is the method provided by the Object class. The default implementation uses ‘==’ operator to compare two objects. For example: method can be overridden like String class. equals() method is used to compare the values of two objects.",
    technology: "java",
  },
  {
    question:
      "Q5. What is a package in Java? List down various advantages of packages.",
    answer:
      "Packages in Java are the collection of related classes and interfaces which are bundled together. By using packages, developers can easily modularize the code and optimize its reuse. Also, the code within the packages can be imported by other classes and reused. Below I have listed down a few of its advantages:\nPackages help in avoiding name clashes\nThey provide easier access control on the code\nPackages can also contain hidden classes which are not visible to the outer classes and only used within the package\nCreates a proper hierarchical structure which makes it easier to locate the related classes",
    technology: "java",
  },
  {
    question: "Q6. Why pointers are not used in Java?",
    answer:
      "Java doesn’t use pointers because they are unsafe and increase the complexity of the program. Since Java is known for its simplicity of code, adding the concept of pointers would contradict this. Moreover, since the JVM is responsible for implicit memory allocation, pointers are discouraged to avoid direct access to memory by the user.",
    technology: "java",
  },
  {
    question: "Q7. What is JIT compiler in Java?",
    answer:
      "JIT stands for Just-In-Time compiler in Java. It is a program that helps in converting the Java bytecode into instructions that are sent directly to the processor. By default, the JIT compiler is enabled in Java and is activated whenever a Java method is invoked. The JIT compiler then compiles the bytecode of the invoked method into native machine code, compiling it ‘just in time’ to execute. Once the method has been compiled, the JVM summons the compiled code of that method directly rather than interpreting it. This is why it is often responsible for the performance optimization of Java applications at runtime.",
    technology: "java",
  },
  {
    question: "Q8. What are access modifiers in Java?",
    answer:
      "In Java, access modifiers are special keywords which are used to restrict the access of a class, constructor, data member, and method in another class. Java supports four types of access modifiers:\nDefault\nPrivate\nProtected\nPublic",
    technology: "java",
  },
  {
    question: "Q9. Define a Java Class.",
    answer:
      "A class in Java is a blueprint which includes all your data. A class contains fields (variables) and methods to describe the behavior of an object. Let’s have a look at the syntax of a class.\n\nclass Abc {\nmember variables // class body\nmethods}",
    technology: "java",
  },
  {
    question: "Q10. What is an object in Java and how is it created?",
    answer:
      "An object is a real-world entity that has a state and behavior. An object has three characteristics:\nState\nBehavior\nIdentity\nAn object is created using the ‘new’ keyword. For example:\nClassName obj = new ClassName();",
    technology: "java",
  },
  {
    question: "1. What is JavaScript?",
    answer:
      "JavaScript is a client-side as well as server side scripting language that can be inserted into HTML pages and is understood by web browsers. JavaScript is also an Object based Programming language",
    technology: "javascript",
  },
  {
    question: "2. Enumerate the differences between Java and JavaScript?",
    answer:
      "Java is a complete programming language. In contrast, JavaScript is a coded program that can be introduced to HTML pages. These two languages are not at all inter-dependent and are designed for different intents. Java is an object-oriented programming (OOPS) or structured programming language like C++ or C, whereas JavaScript is a client-side scripting language.",
    technology: "javascript",
  },
  {
    question: "3. What are JavaScript Data Types?",
    answer:
      "Following are the JavaScript Data types:\n\nNumber\nString\nBoolean\nObject\nUndefined",
    technology: "javascript",
  },
  {
    question: "4. What is the use of isNaN function?",
    answer:
      "isNaN function returns true if the argument is not a number; otherwise, it is false.",
    technology: "javascript",
  },
  {
    question: "5. Between JavaScript and an ASP script, which is faster?",
    answer:
      "JavaScript is faster. JavaScript is a client-side language and thus does not need the assistance of the web server to execute. On the other hand, ASP is a server-side language and hence is always slower than JavaScript. JavaScript is now also a server-side language (Node.js).",
    technology: "javascript",
  },
  {
    question: "6. What is negative infinity?",
    answer:
      "Negative Infinity is a number in JavaScript which can be derived by dividing a negative number by zero.",
    technology: "javascript",
  },
  {
    question: "7. Is it possible to break JavaScript Code into several lines?",
    answer:
      "Breaking within a string statement can be done by using a backslash, '\\', at the end of the first line. If you change to a new line when not within a string statement, JavaScript ignores the break in line.",
    technology: "javascript",
  },
  {
    question: "8. Which company developed JavaScript?",
    answer: "Netscape is the software company that developed JavaScript.",
    technology: "javascript",
  },
  {
    question: "9. What are undeclared and undefined variables?",
    answer:
      "Undeclared variables are those that do not exist in a program and are not declared. If the program tries to read the value of an undeclared variable, a runtime error is encountered.\n\nUndefined variables are those that are declared in the program but have not been given any value. If the program tries to read the value of an undefined variable, an undefined value is returned.",
    technology: "javascript",
  },
  {
    question: "10. What is a prompt box?",
    answer:
      "A prompt box is a box which allows the user to enter input by providing a text box. A label and box will be provided to enter the text or number.",
    technology: "javascript",
  },

  {
    question: "1. Can you explain the different types of Inheritance?",
    answer:
      "There are four main types of Inheritance in OOPS as listed below:\n\n• Single Inheritance: This includes one base class along with one derived class.\n• Hierarchical Inheritance: This inheritance class includes one base class as well as multiple derived classes of the same base class.\n• Multilevel Inheritance: This includes a class derived from a derived class.\n• Multiple Inheritance: This class includes several base classes as well as a derived class.",
    technology: "oops",
  },
  {
    question: "2. Explain the concept of a hashtable.",
    answer:
      "Hashtable is used to store multiple items. Each of these items is linked with their own unique string key and can be accessed using the key associated with it.",
    technology: "oops",
  },
  {
    question: "3. What is Association?",
    answer:
      "Association can be described as a relationship that exists between two objects with multiplicity.",
    technology: "oops",
  },
  {
    question: "4. Can you touch upon the core concepts of OOPS?",
    answer:
      "The core concepts of OOPS are as below:\n• Encapsulation\n• Polymorphism\n• Inheritance\n• Abstraction\n• Composition\n• Association\n• Aggregation",
    technology: "oops",
  },
  {
    question: "5. Can you list out some examples of tokens?",
    answer:
      "Here are some common examples of tokens:\n• Keywords\n• Commas\n• Constants\n• Identifiers\n• Brackets\n• Operators",
    technology: "oops",
  },
  {
    question:
      "6. Can you describe Polymorphism and list out the different types of Polymorphism?",
    answer:
      "Polymorphism can be termed as the ability to take on more than one form. In OOPS, Polymorphism means a single interface with multiple implementations for a certain class of action.\n\nPolymorphism can further be classified into two distinct types:\n• Static\n• Dynamic",
    technology: "oops",
  },
  {
    question: "7. Can you explain what Access Modifiers are?",
    answer:
      "Access modifiers are used to figure out the scope of the method or variables accessible from other various objects or classes.\n\nAccess modifiers can be of five types:\n• Private\n• Public\n• Protected\n• Friend\n• Protected Friend",
    technology: "oops",
  },
  {
    question: "8. Can you list out the different types of constructors?",
    answer:
      "Constructors are of three types as listed below:\n• Default Constructor: Contains no parameters.\n• Parametric Constructor: Contains parameters. This parameter is used to create a new class instance and for simultaneously passing arguments.\n• Copy Constructor: This is used to create a new object as a copy of an existing object.\n\nIn addition to the above-mentioned questions, here’s an additional list of 8 frequently asked OOPS Interview questions that will surely assist you in your bid to crack your all-important OOPS interview.\n\na. Can you explain what a multicast Delegate is?\nb. Please describe the friend function.\nc. Explain what Information Hiding is in OOPS.\nd. Explain the concepts of Overloading and Overriding Polymorphism.\ne. Describe the concept of Enum?\nf. Explain multiple inheritance.\ng. Can you point out the differences between Shadowing and Overriding?\nh. Touch upon the differences between Static and Dynamic polymorphism.",
    technology: "oops",
  },
  {
    question: "9: What is the relationship between a class and an object?",
    answer:
      "A class acts as a blueprint that defines the properties, states, and behaviors that are common to a number of objects. An object is an instance of the class. For example, you have a class called Vehicle and Car is the object of that class. You can create any number of objects for the class named Vehicle, such as Van, Truck, and Auto.\n\nThe new operator is used to create an object of a class. When an object of a class is instantiated, the system allocates memory for every data member that is present in the class.",
    technology: "oops",
  },
  {
    question: "10: When should I use a struct instead of a class?",
    answer:
      "Do not define a structure unless the type has all of the following characteristics:\n\n1. It logically represents a single value, similar to primitive types (integer, double, and so on).\n2. It has an instance size smaller than 16 bytes.\n3. It is immutable.\n4. It will not have to be boxed frequently.",
    technology: "oops",
  },
  {
    question: "11: What is polymorphism, what is it for, and how is it used?",
    answer:
      "Polymorphism describes a pattern in object-oriented programming in which classes have different functionality while sharing a common interface.\n\nThe beauty of polymorphism is that the code working with the different classes does not need to know which class it is using since they’re all used the same way. A real-world analogy for polymorphism is a button. Everyone knows how to use a button: you simply apply pressure to it. What a button “does,” however, depends on what it is connected to and the context in which it is used — but the result does not affect how it is used. If your boss tells you to press a button, you already have all the information needed to perform the task.",
    technology: "oops",
  },
  {
    question: "12: What do you mean by data encapsulation?",
    answer:
      "Data encapsulation is a concept of binding data and code in a single unit called an object and hiding all the implementation details of a class from the user. It prevents unauthorized access of data and restricts the user to use the necessary data only.",
    technology: "oops",
  },
  {
    question:
      "13: What are abstract classes? What are the distinct characteristics of an abstract class?",
    answer:
      "An abstract class is a class that cannot be instantiated and is always used as a base class.\nThe following are the characteristics of an abstract class:\n\n1. You cannot instantiate an abstract class directly. This implies that you cannot create an object of the abstract class; it must be inherited.\n2. You can have abstract as well as non-abstract members in an abstract class.\n3. You must declare at least one abstract method in the abstract class.\n4. An abstract class is always public.\n5. An abstract class is declared using the abstract keyword.\n\nThe basic purpose of an abstract class is to provide a common definition of the base class that multiple derived classes can share.",
    technology: "oops",
  },
  {
    question: "14: What are similarities between a class and a structure?",
    answer:
      "The following are some of the similarities between a class and a structure:\n\n1. Access specifiers, such as public, private, and protected, are identically used in structures and classes to restrict the access of their data and methods outside their body.\n2. The access level for class members and struct members, including nested classes and structs, is private by default. Private nested types are not accessible from outside the containing type.\n3. Both can have constructors, methods, properties, fields, constants, enumerations, events, and event handlers.\n4. Both structures and classes can implement interfaces to use multiple-inheritance in code.\n5. Both structures and classes can have constructors with parameters.\n6. Both structures and classes can have delegates and events.",
    technology: "oops",
  },
  {
    question: "15: How can you prevent a class from overriding in C#?",
    answer:
      "You can prevent a class from overriding in C# by using the sealed keyword.",
    technology: "oops",
  },
  {
    question: "16: How is method overriding different from method overloading?",
    answer:
      "* Overriding involves the creation of two or more methods with the same name and same signature in different classes (one of them should be the parent class and the other should be the child).\n* Overloading is a concept of using a method at different places with the same name and different signatures within the same class.",
    technology: "oops",
  },
  {
    question:
      "17: Can you specify the accessibility modifier for methods inside the interface?",
    answer:
      "All the methods inside an interface are always public, by default. You cannot specify any other access modifier for them.",
    technology: "oops",
  },
  {
    question:
      "18: Is it possible for a class to inherit the constructor of its base class?",
    answer: "No, a class cannot inherit the constructor of its base class.",
    technology: "oops",
  },
  {
    question: "19. What is the meaning of “IS-A” and “HAS-A” relationship?",
    answer:
      "“IS-A” relationship implies inheritance. A subclass object is said to have “IS-A” relationship with the superclass or interface. If class A extends B, then A “IS-A” B. It is transitive, that is, if class A extends B and class B extends C, then A “IS-A” C. The “instanceof” operator in Java determines the “IS-A” relationship.\n\nWhen a class A has a member reference variable of type B, then A “HAS-A” B. It is also known as Aggregation.",
    technology: "oops",
  },
  {
    question: "20. What is the difference between Association and Dependency?",
    answer:
      "The main difference between Association and Dependency is that in the case of Association, one class has an attribute or member variable of the other class type, but in the case of Dependency, a method takes an argument of the other class type or a method has a local variable of the other class type.",
    technology: "oops",
  },
  {
    question: "1) What is an operating system?",
    answer:
      "The operating system is a software program that facilitates computer hardware to communicate and operate with the computer software. It is the most important part of a computer system without it computer is just like a box.",
    technology: "os",
  },
  {
    question: "2) What is the main purpose of an operating system?",
    answer:
      "There are two main purposes of an operating system:\n\nIt is designed to make sure that a computer system performs well by managing its computational activities.\nIt provides an environment for the development and execution of programs.",
    technology: "os",
  },
  {
    question: "3) What are the different operating systems?",
    answer:
      "Batched operating systems\nDistributed operating systems\nTimesharing operating systems\nMulti-programmed operating systems\nReal-time operating systems",
    technology: "os",
  },
  {
    question: "4) What is a socket?",
    answer:
      "A socket is used to make connection between two applications. Endpoints of the connection are called socket.",
    technology: "os",
  },
  {
    question: "5) What is a real-time system?",
    answer:
      "Real-time system is used in the case when rigid-time requirements have been placed on the operation of a processor. It contains a well defined and fixed time constraints.",
    technology: "os",
  },
  {
    question: "6) What is kernel?",
    answer:
      "Kernel is the core and most important part of a computer operating system which provides basic services for all parts of the OS.",
    technology: "os",
  },
  {
    question: "7) What is monolithic kernel?",
    answer:
      "A monolithic kernel is a kernel which includes all operating system code in a single executable image.",
    technology: "os",
  },
  {
    question: "8) What do you mean by a process?",
    answer:
      "An executing program is known as process. There are two types of processes:\n\nOperating System Processes\nUser Processes",
    technology: "os",
  },
  {
    question: "9) What are the different states of a process?",
    answer:
      "A list of different states of process:\n\nNew Process\nRunning Process\nWaiting Process\nReady Process\nTerminated Process",
    technology: "os",
  },
  {
    question:
      "10) What is the difference between micro kernel and macro kernel?",
    answer:
      "Micro kernel: micro kernel is the kernel which runs minimal performance affecting services for operating system. In micro kernel operating system all other operations are performed by processor.\n\nMacro Kernel: Macro Kernel is a combination of micro and monolithic kernel.",
    technology: "os",
  },
  {
    question: "1) What is Python? What are the benefits of using Python?",
    answer:
      "Python is a programming language with objects, modules, threads, exceptions and automatic memory management. The benefits of pythons are that it is simple and easy, portable, extensible, built-in data structure and it is open source.",
    technology: "python",
  },
  {
    question: "2) What is PEP 8?",
    answer:
      "PEP 8 is a coding convention, a set of recommendation, about how to write your Python code more readable.",
    technology: "python",
  },
  {
    question: "3) What is pickling and unpickling?",
    answer:
      "Pickle module accepts any Python object and converts it into a string representation and dumps it into a file by using dump function, this process is called pickling. While the process of retrieving original Python objects from the stored string representation is called unpickling.",
    technology: "python",
  },
  {
    question: "4) How memory is managed in Python?",
    answer:
      "Python memory is managed by Python private heap space. All Python objects and data structures are located in a private heap. The programmer does not have an access to this private heap and interpreter takes care of this Python private heap.\nThe allocation of Python heap space for Python objects is done by Python memory manager. The core API gives access to some tools for the programmer to code.\nPython also have an inbuilt garbage collector, which recycle all the unused memory and frees the memory and makes it available to the heap space.",
    technology: "python",
  },
  {
    question:
      "5) What are the tools that help to find bugs or perform static analysis?",
    answer:
      "PyChecker is a static analysis tool that detects the bugs in Python source code and warns about the style and complexity of the bug. Pylint is another tool that verifies whether the module meets the coding standard.",
    technology: "python",
  },
  {
    question: "6) What are Python decorators?",
    answer:
      "A Python decorator is a specific change that we make in Python syntax to alter functions easily.",
    technology: "python",
  },
  {
    question: "7) What is the difference between list and tuple?",
    answer:
      "The difference between list and tuple is that list is mutable while tuple is not. Tuple can be hashed for e.g as a key for dictionaries.",
    technology: "python",
  },
  {
    question: "8) How are arguments passed by value or by reference?",
    answer:
      "Everything in Python is an object and all variables hold references to the objects. The references values are according to the functions; as a result you cannot change the value of the references. However, you can change the objects if it is mutable.",
    technology: "python",
  },
  {
    question: "9) What is Dict and List comprehensions?",
    answer:
      "They are syntax constructions to ease the creation of a Dictionary or List based on existing iterable.",
    technology: "python",
  },
  {
    question: "10) What are the built-in type does python provides?",
    answer:
      "There are mutable and Immutable types of Pythons built in types Mutable built-in types\nList\nSets\nDictionaries\nImmutable built-in types\nStrings\nTuples\nNumbers",
    technology: "python",
  },
  {
    question: "1. What are the different features of an RDBMS?",
    answer:
      "Name. Every relation in a relational database should have a name which is unique among all other relations.\nAttributes. Each column in a relation is called an attribute.\nTuples. Each and every row in a relation is called a tuple. A tuple defines a collection of attribute values.",
    technology: "rdbms",
  },
  {
    question: "2. Explain the E-R Model?",
    answer:
      "E-R model is an Entity-Relationship model. E-R model is based on a real-world which is made up of entities and related objects. Entities are illustrated in a database by a set of attributes.",
    technology: "rdbms",
  },
  {
    question: "3. Define the object-oriented model?",
    answer:
      "The object-oriented model is based on collections of objects. An object accommodates values which are stored in instance variables inside the object. Objects having an identical type of values and the exact same methods are grouped together into classes.",
    technology: "rdbms",
  },
  {
    question: "4. Explain three levels of data abstraction?",
    answer:
      "1.Physical level: This is the lowest level of abstraction and it describes how data is stored.\n\n2.Logical level: The next level of abstraction is logical, it describes what type of data is stored in a database and what is the relationship between these data.\n\n3.View level: The highest level of abstraction and it describes the only entire database.",
    technology: "rdbms",
  },
  {
    question: "5. What are different Codd’s 12 rules for Relational Database?",
    answer:
      "Codd’s 12 rules are a set of thirteen rules (numbered zero to twelve) proposed by Edgar F. Codd.\nCodd’s rules: –\nRule 0: The system has to qualify as Relational, as a Database, and also as a Management System.\nRule 1: The information rule: Each and every information in the database is to be represented uniquely, mainly name values in column positions within a different row of a table.\nRule 2: The guaranteed access rule: All data must be ingressive. It says that every scalar value in the database must be correctly/logically addressable.\nRule 3: Systematic treatment of null values: The DBMS must allow each tuple to remain null.\nRule 4: Active online catalog (database’s structure) based on the relational model: The system must support an online, relational etc. structure which is ingressive to allowed users by means of their regular query.\nRule 5: The comprehensive data sublanguage: The system has to assist a minimum of one relational language that:\n1.Has a linear syntax\n2.Which can be used as both interactively and within application programs,\n3.It supports data definition operations(DDL), data manipulation operations(DML), security and integrity constraints, and transaction management operations (begin, commit, and rollback).\nRule 6: The view updating rule: All views that theoretically improve must be upgradable by the system.\nRule 7: High-level insert, update, and delete: The system must support insert, update, and delete operators.\nRule 8: Physical data independence: Modify the physical level (how the data is stored, using arrays or linked lists etc.) must not require a modification to an application.\nRule 9: Logical data independence: Modify the logical level (tables, columns, rows etc.) must not require a modification to an application.\nRule 10: Integrity independence: Integrity constraints must be identified individually from application programs and stored in the catalog.\nRule 11: Distribution independence: The distribution of portions of a database to different locations should not be visible to users of the database.\nRule 12: The nonsubversion rule: If the system provides a low-level (i.e. records) interface, then that interface can’t be used to subvert the system.",
    technology: "rdbms",
  },
  {
    question:
      "6.What is normalization? and what explains different normalization forms?",
    answer:
      "Database normalization is a process of organizing data to minimize data redundancy. Which in turn ensures data consistency. There are many problems associated with data redundancy such as disk space wastage, data inconsistency, DML (Data Manipulation Language) queries become slow. There are different normalisation forms: – 1NF, 2NF, 3NF, BCNF, 4NF,5NF, ONF, DKNF.\n1.1NF: – The data in each column should be atomic number multiple values separated by a comma. The table does not contain any repeating column groups. Identity each record uniquely using the primary key.\n2.2NF: – The table should match all the conditions of 1NF and move redundant data to a separate table. Moreover, it creates a relationship between these tables using foreign keys.\n3.3NF: – for a 3NF table should fulfill all the conditions of 1NF and 2NF. 3NF doesn’t contain attributes which are partially dependent upon primary key.",
    technology: "rdbms",
  },
  {
    question: "7. Define primary key, foreign key, candidate key, super key?",
    answer:
      "Primary key: The primary key is the key that doesn’t allow duplicate values and null values. A primary key can be defined at column level or table level. Only one primary key per table is allowed.\nForeign key: foreign key allows the values present in the referenced column only. It allows duplicate or null values. It can be defined as a column level or table level. It can reference a column of a unique/primary key.\nCandidate Key: A Candidate key is minimum super key, there is no proper subgroup of Candidate key attributes can be a super key.\nSuper Key: A superkey is a set of attributes of a relation schema on which all attributes of the schema are partially dependent. No two rows can have the same value of super key attributes.",
    technology: "rdbms",
  },
  {
    question: "8. What is a different type of indexes?",
    answer:
      "Indexes are: –\nClustered index: – It is the index at which data is physically stored in the disk. Therefore, only one clustered index can be created to a database table.\nNon-clustered index: – It does not define physical data but it defines a logical ordering. Typically, B-Tree or B+ trees are created for this purpose.",
    technology: "rdbms",
  },
  {
    question: "9. What are the advantages of RDBMS?",
    answer:
      "•Controlling Redundancy.\n•Integrity can be enforced.\n•Inconsistency can be avoided.\n•Data can be shared.\n•Standard can be enforced.",
    technology: "rdbms",
  },
  {
    question: "10. Name some subsystems of RDBMS?",
    answer:
      "Input-output, Security, Language Processing, Storage Management, Logging and Recovery, Distribution Control, Transaction Control, Memory Management.",
    technology: "rdbms",
  },
  {
    question: "1.  Differentiate between Real DOM and Virtual DOM.",
    answer:
      "1. Real DOM\n1. It updates slow.\n2. Can directly update HTML.\n3. Creates a new DOM if element updates.\n4. DOM manipulation is very expensive.\n5. Too much of memory wastage.\n\nVirtual DOM\n1. It updates faster.\n2. Can’t directly update HTML.\n3. Updates the JSX if element updates.\n4. DOM manipulation is very easy.\n5. No memory wastage.",
    technology: "react",
  },
  {
    question: "2. What is React?",
    answer:
      "1. React is a front-end JavaScript library developed by Facebook in 2011.\n2. It follows the component based approach which helps in building reusable UI components.\n3. It is used for developing complex and interactive web and mobile UI.\n4. Even though it was open-sourced only in 2015, it has one of the largest communities supporting it.",
    technology: "react",
  },
  {
    question: "3. What are the features of React?",
    answer:
      "Major features of React are listed below:\n\n1. It uses the virtual DOM instead of the real DOM.\n2. It uses server-side rendering.\n3. It follows uni-directional data flow or data binding.",
    technology: "react",
  },
  {
    question: "4. List some of the major advantages of React.",
    answer:
      "Some of the major advantages of React are:\n\n1. It increases the application’s performance\n2. It can be conveniently used on the client as well as server side\n3. Because of JSX, code’s readability increases\n4. React is easy to integrate with other frameworks like Meteor, Angular, etc\n5. Using React, writing UI test cases become extremely easy",
    technology: "react",
  },
  {
    question: "5. What are the limitations of React?",
    answer:
      "Limitations of React are listed below:\n\n1. React is just a library, not a full-blown framework\n2. Its library is very large and takes time to understand\n3. It can be little difficult for the novice programmers to understand\n4. Coding gets complex as it uses inline templating and JSX\n5. React Interview Questions and Answers | Edureka",
    technology: "react",
  },
  {
    question: "6. What is JSX?",
    answer:
      "JSX is a shorthand for JavaScript XML. This is a type of file used by React which utilizes the expressiveness of JavaScript along with HTML like template syntax. This makes the HTML file really easy to understand. This file makes applications robust and boosts its performance.",
    technology: "react",
  },
  {
    question: "7. What do you understand by Virtual DOM? Explain its working.",
    answer:
      "A virtual DOM is a lightweight JavaScript object which originally is just the copy of the real DOM. It is a node tree that lists the elements, their attributes and content as Objects and their properties. React’s render function creates a node tree out of the React components. It then updates this tree in response to the mutations in the data model which is caused by various actions done by the user or by the system.",
    technology: "react",
  },
  {
    question: "8. Why can’t browsers read JSX?",
    answer:
      "Browsers can only read JavaScript objects but JSX in not a regular JavaScript object. Thus to enable a browser to read JSX, first, we need to transform JSX file into a JavaScript object using JSX transformers like Babel and then pass it to the browser.",
    technology: "react",
  },
  {
    question:
      "9. What do you understand from “In React, everything is a component.”",
    answer:
      "Components are the building blocks of a React application’s UI. These components split up the entire UI into small independent and reusable pieces. Then it renders each of these components independent of each other without affecting the rest of the UI.",
    technology: "react",
  },
  {
    question: "10. Explain the purpose of render() in React.",
    answer:
      "Each React component must have a render() mandatorily. It returns a single React element which is the representation of the native DOM component. If more than one HTML element needs to be rendered, then they must be grouped together inside one enclosing tag such as <form>, <group>,<div> etc. This function must be kept pure i.e., it must return the same result each time it is invoked.",
    technology: "react",
  },
  {
    question: "Q1. What is SDLC and what is it used for?",
    answer:
      "SDLC (Software Development Life Cycle) is the process of design and development of a product or service to be delivered to the customer that is being followed for the software or systems projects in the Information Technology or Hardware Organizations. SDLC framework is useful in delivering the products or customers which ensures high quality and efficient.",
    technology: "sdlc",
  },
  {
    question: "Q2. What are the different types of SDLC methodologies?",
    answer:
      "This is the basic SDLC Interview Questions asked in an interview. The different models of SDLC are –\n\n1. Waterfall model\n2. Agile model\n3. Iterative or incremental model\n4. Spiral model\n5. RAD – Rapid Application Development model\n6. V-Shaped model\n7. Evolutionary prototype model",
    technology: "sdlc",
  },
  {
    question: "Q3. What are the different phases of the Waterfall model?",
    answer:
      "The different phases or steps involved in the waterfall model are Requirements, Design, Execution, Testing, and Release. This model is of sequential form and moves downward without any deviations. Every phase will start only after the completion of the previous one. This process was being followed for a long time and a traditional approach and has been the best one since agile is adopted recently. This type of model does not involve any kind of frequent requirement changes and needs follows clear documentation from the beginning to the end. The phases and activities are well planned.",
    technology: "sdlc",
  },
  {
    question: "Q4. What is CMM Maturity Level and what is its importance?",
    answer:
      "The CMM (Capability Maturity Model) is a standard or benchmark which is used in the process of the development model in an organization to study or know the maturity of the processes being followed in an organization. The CMMI level is used to determine the quality or maturity of a software development process in an organization i.e. either software or hardware. It will be used to assess the organization on a scale of five different levels and the processes being followed in the organization. The five different levels are Initial, Repeatable, Defined, Capable (Managed) and Efficient (Optimizing).",
    technology: "sdlc",
  },
  {
    question: "Q5. What are the drawbacks of Waterfall model?",
    answer:
      "The drawbacks of the waterfall model are – It will not be ideal for larger and complex projects when the requirements are not clearly documented and not clear. It is not easier and also not possible to go back to any stage or phase during the Software Development Process. No software product or service will be delivered until the last stages or phases of the Software Development Life Cycle which will be a form of risk. The process of testing can also be completed only after the completion of the Development phase and also cannot be carried out in parallel.",
    technology: "sdlc",
  },
  {
    question:
      "Q6. Who are the different team members involved in the different phases of the Waterfall model?",
    answer:
      "The different team members or key members involved in Waterfall model development process are Technical Manager, Developers, Senior Developers, Business analyst, Technical Lead or System Architect or Solutions Architect or Technical Architect in the Design Phase and the Developers, Senior Developers in the Coding phase. Testers or Analysts in the Testing Phase. Project Manager, Program Manager, and Maintenance Team will be in the Maintenance phase of the Software Development Life Cycle process. The team members involved in the different project phases also depends on the structure of the organization and the roles and responsibilities being followed or maintained by the particular organization.",
    technology: "sdlc",
  },
  {
    question: "Q7. What are LLDs or HLDs in SDLC?",
    answer:
      "The LLD (Low-Level Design) and HLD (High-level Design) are used to analyze and understand the project in a high level and low-level overview to different types of team members to the customers depending on the technical or business knowledge of the person. The Low-level Design is a detailed design implementation which will be helpful in the development process for the Developers whereas the High-Level Design will be given by Architects to proceed with the development process initially. This will be easier to know or look at a glance to understand about the project easily.",
    technology: "sdlc",
  },
  {
    question: "Q8. What are the different phases in the Agile model?",
    answer:
      "The different phases involved in the Agile model are Planning, Requirements, Analysis, Design, Coding, Unit Testing, System Integration Testing, Non-Functional Testing, and Acceptance Testing. The Agile model will be followed using any Agile boards such as Scrum or Kanban. There will be a number of Sprints to be followed and all the deliverables will be done in the form of Story Points.",
    technology: "sdlc",
  },
  {
    question: "Q9. What are the advantages of the agile model?",
    answer:
      "This is the advanced SDLC Interview Questions asked in an interview. The different advantages of following the Agile model in a Software Development Life Cycle process are as below:\n\nIt is easier and simple to understand and to use and implement.\nIt has simple and easier deliverables which are planned frequently based on Sprints which ensures frequent and high-quality deliverables.\nIt is very good for smaller and also larger or complex projects and ends up with high-quality project deliverables.",
    technology: "sdlc",
  },
  {
    question: "Q10. What is a V-shaped model in SDLC?",
    answer:
      "The V-shaped model is a type of extension model and the testing will be planned earlier. The different steps are given below:\n\nPlanning\nRequirements\nArchitecture\nDesign\nImplementation\nUnit Testing\nIntegration Testing\nSystem and Acceptance Testing\nMaintenance",
    technology: "sdlc",
  },
  {
    question: "1. What is SQL?",
    answer:
      "SQL stands for Structured Query Language , and it is used to communicate with the Database. This is a standard language used to perform tasks such as retrieval, updation, insertion and deletion of data from a database.\n\nStandard SQL Commands are Select.",
    technology: "sql",
  },
  {
    question: "2. What is a Database?",
    answer:
      "Database is nothing but an organized form of data for easy access, storing, retrieval and managing of data. This is also known as structured form of data which can be accessed in many ways.\n\nExample: School Management Database, Bank Management Database.",
    technology: "sql",
  },
  {
    question: "3. What are tables and Fields?",
    answer:
      "A table is a set of data that are organized in a model with Columns and Rows. Columns can be categorized as vertical, and Rows are horizontal. A table has specified number of column called fields but can have any number of rows which is called record.\n\nExample:.\n\nTable: Employee.\nField: Emp ID, Emp Name, Date of Birth.\n\nData: 201456, David, 11/15/1960.",
    technology: "sql",
  },
  {
    question: "4. What is a primary key?",
    answer:
      "A primary key is a combination of fields which uniquely specify a row. This is a special kind of unique key, and it has implicit NOT NULL constraint. It means, Primary key values cannot be NULL.",
    technology: "sql",
  },
  {
    question: "5. What is a unique key?",
    answer:
      "A Unique key constraint uniquely identified each record in the database. This provides uniqueness for the column or set of columns.\n\nA Primary key constraint has automatic unique constraint defined on it. But not, in the case of Unique Key.\n\nThere can be many unique constraint defined per table, but only one Primary key constraint defined per table.",
    technology: "sql",
  },
  {
    question: "6. What is a foreign key?",
    answer:
      "A foreign key is one table which can be related to the primary key of another table. Relationship needs to be created between two tables by referencing foreign key with the primary key of another table.",
    technology: "sql",
  },
  {
    question: "7. What is a join?",
    answer:
      "This is a keyword used to query data from more tables based on the relationship between the fields of the tables. Keys play a major role when JOINs are used.",
    technology: "sql",
  },
  {
    question: "8. What is normalization?",
    answer:
      "Normalization is the process of minimizing redundancy and dependency by organizing fields and table of a database. The main aim of Normalization is to add, delete or modify field that can be made in a single table.",
    technology: "sql",
  },
  {
    question: "9. What is Denormalization.",
    answer:
      "DeNormalization is a technique used to access the data from higher to lower normal forms of database. It is also process of introducing redundancy into a table by incorporating data from the related tables.",
    technology: "sql",
  },
  {
    question: "10. What is a View?",
    answer:
      "A view is a virtual table which consists of a subset of data contained in a table. Views are not virtually present, and it takes less space to store. View can have data of one or more tables combined, and it is depending on the relationship.",
    technology: "sql",
  },
  {
    question: "1. What is Software Testing?",
    answer:
      "According to ANSI/IEEE 1059 standard – A process of analyzing a software item to detect the differences between existing and required conditions (i.e., defects) and to evaluate the features of the software item.",
    technology: "testing",
  },
  {
    question: "2. What are Quality Assurance and Quality Control?",
    answer:
      "Quality Assurance: Quality Assurance involves in process-oriented activities. It ensures the prevention of defects in the process used to make Software Application. So the defects don’t arise when the Software Application is being developed.\nQuality Control: Quality Control involves in product-oriented activities. It executes the program or code to identify the defects in the Software Application.",
    technology: "testing",
  },
  {
    question: "3. What is Verification in software testing?",
    answer:
      "Verification is the process, to ensure that whether we are building the product right i.e., to verify the requirements which we have and to verify whether we are developing the product accordingly or not. Activities involved here are Inspections, Reviews, Walk-throughs.",
    technology: "testing",
  },
  {
    question: "4. What is Validation in software testing?",
    answer:
      "Validation is the process, whether we are building the right product i.e., to validate the product which we have developed is right or not. Activities involved in this is Testing the software application.",
    technology: "testing",
  },
  {
    question: "5. What is Static Testing?",
    answer:
      "Static Testing involves in reviewing the documents to identify the defects in the early stages of SDLC.",
    technology: "testing",
  },
  {
    question: "6. What is Dynamic Testing?",
    answer:
      "Dynamic testing involves in the execution of code. It validates the output with the expected outcome.",
    technology: "testing",
  },
  {
    question: "7. What is White Box Testing?",
    answer:
      "White Box Testing is also called as Glass Box, Clear Box, and Structural Testing. It is based on applications internal code structure. In white-box testing, an internal perspective of the system, as well as programming skills, are used to design test cases. This testing usually was done at the unit level.",
    technology: "testing",
  },
  {
    question: "8. What is Black Box Testing?",
    answer:
      "Black Box Testing is a software testing method in which testers evaluate the functionality of the software under test without looking at the internal code structure. This can be applied to every level of software testing such as Unit, Integration, System and Acceptance Testing.",
    technology: "testing",
  },
  {
    question: "9. What is Grey Box Testing?",
    answer:
      "Grey box is the combination of both White Box and Black Box Testing. The tester who works on this type of testing needs to have access to design documents. This helps to create better test cases in this process.",
    technology: "testing",
  },
  {
    question: "10. What is Positive and Negative Testing?",
    answer:
      "Positive Testing: It is to determine what system supposed to do. It helps to check whether the application is justifying the requirements or not.\n\nNegative Testing: It is to determine what system not supposed to do. It helps to find the defects from the software.",
    technology: "testing",
  },
];

export const otherLearningResource = [
  {
    technology: "android",
    imgsource: "android_tech.jpeg",
    title: "50 Android Interview Questions & Answers",
    source: "(guru99)",
    tag1: "android",
    tag2: "Interview Questions",
    link: "https://www.eguru99.com/android-interview-questions.html",
  },
  {
    technology: "android",
    imgsource: "android_tech.jpeg",
    title: "Top 50 Android Interview Questions You Must Prepare",
    source: "(edureka)",
    tag1: "android",
    tag2: "Interview Questions",
    link: "https://www.edureka.co/blog/interview-questions/top-android-interview-questions-for-beginners/",
  },
  {
    technology: "android",
    imgsource: "android_tech.jpeg",
    title: "Top 35 Android Interview Questions and Answers",
    source: "(softwaretestinghelp)",
    tag1: "android",
    tag2: "Interview Questions",
    link: "https://www.softwaretestinghelp.com/android-interview-questions/",
  },
  {
    technology: "android",
    imgsource: "android_tech.jpeg",
    title: "Android Interview Questions",
    source: "(tutorialspoint)",
    tag1: "android",
    tag2: "Interview Questions",
    link: "https://www.tutorialspoint.com/android/android_interview_questions.htm",
  },
  {
    technology: "android",
    imgsource: "android_tech.jpeg",
    title: "Android Interview Questions Cheat Sheet",
    source: "(android.jlelse.eu)",
    tag1: "android",
    tag2: "Interview Questions",
    link: "https://android.jlelse.eu/android-interview-questions-cheat-sheet-96ea01c88def",
  },
  {
    technology: "android",
    imgsource: "android_tech.jpeg",
    title: "50 Top Android Interview Questions And Answers",
    source: "(hackr.io)",
    tag1: "android",
    tag2: "Interview Questions",
    link: "https://hackr.io/blog/android-interview-questions",
  },

  {
    technology: "angular",
    imgsource: "angular_tech.jpeg",
    title: "Top 50 Angular Interview Questions & Answers",
    source: "(hackr.io/)",
    tag1: "angular",
    tag2: "Interview Questions",
    link: "https://hackr.io/blog/angular-interview-questions",
  },
  {
    technology: "angular",
    imgsource: "angular_tech.jpeg",
    title: "Top Angular Interview Questions You Must Prepare For 2020",
    source: "(edureka)",
    tag1: "angular",
    tag2: "Interview Questions",
    link: "https://www.edureka.co/blog/interview-questions/top-angularjs-interview-questions-2016/",
  },
  {
    technology: "angular",
    imgsource: "angular_tech.jpeg",
    title: "40+ Top Angular 6 Interview Questions",
    source: "(best interview question)",
    tag1: "angular",
    tag2: "Interview Questions",
    link: "https://www.bestinterviewquestion.com/angular-6-interview-questions",
  },
  {
    technology: "angular",
    imgsource: "angular_tech.jpeg",
    title: "26 Top Angular 8 Interview Questions And Answers",
    source: "(fullstack.cafe)",
    tag1: "angular",
    tag2: "Interview Questions",
    link: "https://www.fullstack.cafe/blog/angular-8-interview-questions",
  },
  {
    technology: "angular",
    imgsource: "angular_tech.jpeg",
    title: "AngularJS Interview Questions",
    source: "(tutorialspoint)",
    tag1: "angular",
    tag2: "Interview Questions",
    link: "https://www.tutorialspoint.com/angularjs/angularjs_interview_questions.htm",
  },
  {
    technology: "angular",
    imgsource: "angular_tech.jpeg",
    title: "Top 30 Interview Questions And Answers On Angular 5",
    source: "(greycampus)",
    tag1: "angular",
    tag2: "Interview Questions",
    link: "https://www.greycampus.com/blog/programming/top-30-interview-questions-and-answers-on-angular-5",
  },
  {
    technology: "bootstrap",
    imgsource: "bootstrap_tech.jpeg",
    title: "50 Top Bootstrap Interview Questions [Updated]",
    source: "(hackr.io)",
    tag1: "bootstrap",
    tag2: "Interview Questions",
    link: "https://hackr.io/blog/bootstrap-interview-questions",
  },
  {
    technology: "bootstrap",
    imgsource: "bootstrap_tech.jpeg",
    title: "Bootstrap - Interview Questions",
    source: "(tutorialspoint)",
    tag1: "bootstrap",
    tag2: "Interview Questions",
    link: "https://www.tutorialspoint.com/bootstrap/bootstrap_interview_questions.htm",
  },
  {
    technology: "bootstrap",
    imgsource: "bootstrap_tech.jpeg",
    title: "Top 25 Bootstrap Interview Questions & Answers",
    source: "(guru99)",
    tag1: "bootstrap",
    tag2: "Interview Questions",
    link: "https://career.guru99.com/top-25-bootstrap-interview-questions/",
  },
  {
    technology: "bootstrap",
    imgsource: "bootstrap_tech.jpeg",
    title: "Top 45 Bootstrap Interview Questions | Web Development",
    source: "(edureka)",
    tag1: "bootstrap",
    tag2: "Interview Questions",
    link: "https://www.edureka.co/blog/interview-questions/bootstrap-interview-questions/",
  },
  {
    technology: "bootstrap",
    imgsource: "bootstrap_tech.jpeg",
    title: "Top 10+ Bootstrap 4 Interview Questions and Answers in 2020",
    source: "(best interview question)",
    tag1: "bootstrap",
    tag2: "Interview Questions",
    link: "https://www.bestinterviewquestion.com/bootstrap-4-interview-questions",
  },
  {
    technology: "bootstrap",
    imgsource: "bootstrap_tech.jpeg",
    title: "20+ Bootstrap Interview Questions in 2020",
    source: "(online interview questions)",
    tag1: "bootstrap",
    tag2: "Interview Questions",
    link: "https://www.onlineinterviewquestions.com/bootstrap-interview-questions-answers/",
  },

  {
    technology: "cpp",
    imgsource: "cpp_tech.jpeg",
    title: "50+ Best C++ Interview Questions & Answers in 2020",
    source: "(hackr.io)",
    tag1: "C++",
    tag2: "questions",
    link: "https://hackr.io/blog/cpp-interview-questions",
  },
  {
    technology: "cpp",
    imgsource: "cpp_tech.jpeg",
    title: "Commonly Asked C++ Interview Questions",
    source: "(geeksforgeeks)",
    tag1: "C++",
    tag2: "Questions",
    link: "https://www.geeksforgeeks.org/commonly-asked-c-interview-questions-set-1/",
  },
  {
    technology: "cpp",
    imgsource: "cpp_tech.jpeg",
    title: "C++ Interview Questions",
    source: "(tutorialspoint)",
    tag1: "C++",
    tag2: "Interview",
    link: "https://www.tutorialspoint.com/cplusplus/cpp_interview_questions.htm",
  },
  {
    technology: "cpp",
    imgsource: "cpp_tech.jpeg",
    title: "Top 39 C++ Interview Questions",
    source: "(javatpoint)",
    tag1: "C++",
    tag2: "Questions",
    link: "https://www.javatpoint.com/cpp-interview-questions",
  },
  {
    technology: "cpp",
    imgsource: "cpp_tech.jpeg",
    title: "Top 24 C++ Interview Questions & Answers",
    source: "(guru99)",
    tag1: "C++",
    tag2: "Interview",
    link: "https://www.guru99.com/cpp-interview-questions.html",
  },
  {
    technology: "cpp",
    imgsource: "cpp_tech.jpeg",
    title: "24 Essential C++ Interview Questions and Answers",
    source: "(toptal)",
    tag1: "C++",
    tag2: "Questions",
    link: "https://www.toptal.com/c-plus-plus/interview-questions",
  },
  {
    technology: "c",
    imgsource: "c_tech.jpeg",
    title: "Commonly Asked C Programming Interview Questions",
    source: "(geeksforgeeks)",
    tag1: "C",
    tag2: "Questions",
    link: "https://www.geeksforgeeks.org/commonly-asked-c-programming-interview-questions-set-1/",
  },
  {
    technology: "c",
    imgsource: "c_tech.jpeg",
    title: "C Programming Interview Questions",
    source: "(javatpoint)",
    tag1: "C",
    tag2: "Questions",
    link: "https://www.javatpoint.com/c-interview-questions",
  },
  {
    technology: "c",
    imgsource: "c_tech.jpeg",
    title: "C Programming Interview Questions",
    source: "(tutorialspoint)",
    tag1: "Interview",
    tag2: "Questions",
    link: "https://www.tutorialspoint.com/cprogramming/cprogramming_interview_questions.htm",
  },
  {
    technology: "c",
    imgsource: "c_tech.jpeg",
    title: "Commonly Asked Technical Interview Questions on C",
    source: "(faceprep)",
    tag1: "technical",
    tag2: "interview",
    link: "https://www.faceprep.in/c-plus-plus/technical-interview-questions-on-cpp-programming/",
  },
  {
    technology: "c",
    imgsource: "c_tech.jpeg",
    title: "Top 100 C Programming Interview Questions & Answers",
    source: "(guru99)",
    tag1: "C",
    tag2: "Interview",
    link: "https://www.guru99.com/c-programming-interview-questions.html",
  },
  {
    technology: "c",
    imgsource: "c_tech.jpeg",
    title: "40+ Best C Interview Questions & Answers in 2020",
    source: "(hackr.io)",
    tag1: "interview",
    tag2: "C",
    link: "https://hackr.io/blog/c-interview-questions",
  },
  {
    technology: "cloud_computing",
    imgsource: "cn_tech.jpeg",
    title: "Top Cloud Computing Interview Questions",
    source: "(intellipaat)",
    tag1: "Cloud Computing",
    link: "https://intellipaat.com/blog/interview-question/cloud-computing-interview-questions/",
  },
  {
    technology: "cloud_computing",
    imgsource: "cn_tech.jpeg",
    title: "Cloud Computing Interview Questions & Answers (Fresher)",
    source: "(janbask)",
    tag1: "cloud",
    tag2: "interview",
    link: "https://www.janbasktraining.com/blog/cloud-computing-interview-questions-answers/",
  },
  {
    technology: "cloud_computing",
    imgsource: "cn_tech.jpeg",
    title: "40 Latest Cloud Computing Interview Questions",
    source: "(data-flair.training)",
    tag1: "Cloud",
    tag2: "interview",
    link: "https://data-flair.training/blogs/cloud-computing-interview-questions/",
  },
  {
    technology: "cloud_computing",
    imgsource: "cn_tech.jpeg",
    title: "TOP 250+ Cloud Computing Interview Questions and Answers",
    source: "(wisdomjobs)",
    tag1: "cloud",
    tag2: "Answer",
    link: "https://www.wisdomjobs.com/e-university/cloud-computing-interview-questions.html",
  },
  {
    technology: "cloud_computing",
    imgsource: "cn_tech.jpeg",
    title: "Top 50+ Cloud Computing Interview Questions 2020",
    source: "(gangboard)",
    tag1: "Cloud",
    tag2: "Computing",
    link: "https://www.gangboard.com/blog/cloud-computing-interview-questions-and-answers",
  },
  {
    technology: "cloud_computing",
    imgsource: "cn_tech.jpeg",
    title: "Top 50 Frequently Asked Cloud Computing Interview Questions",
    source: "(ubuntupit)",
    tag1: "cloud computing",
    tag2: "interview questions",
    link: "https://www.ubuntupit.com/frequently-asked-cloud-computing-interview-questions/",
  },
  {
    technology: "networking",
    imgsource: "cn_tech.jpeg",
    title: "Top 47 Networking Interview Questions",
    source: "(javatpoint)",
    tag1: "Interview Questions",
    link: "https://www.javatpoint.com/networking-interview-questions",
  },
  {
    technology: "networking",
    imgsource: "cn_tech.jpeg",
    title: "Commonly asked Computer Networks Interview Questions",
    source: "()",
    tag1: "Networks",
    tag2: "Questions",
    link: "https://www.geeksforgeeks.org/commonly-asked-computer-networks-interview-questions-set-1/",
  },
  {
    technology: "networking",
    imgsource: "cn_tech.jpeg",
    title: "Hardware and Networking Interview Questions & Answers",
    source: "(learning.naukri)",
    tag1: "interview",
    link: "https://learning.naukri.com/articles/networking-interview-questions-answers/",
  },
  {
    technology: "networking",
    imgsource: "cn_tech.jpeg",
    title: "TOP 250+ Networking Interview Questions and Answers",
    source: "(wisdom jobs)",
    tag1: "Computer Network",
    link: "https://www.wisdomjobs.com/e-university/networking-interview-questions.html",
  },
  {
    technology: "networking",
    imgsource: "cn_tech.jpeg",
    title: "10 Basic Interview Questions and Answers",
    source: "(tecmint)",
    tag1: "computer network",
    link: "https://www.tecmint.com/networking-interview-questions/",
  },
  {
    technology: "networking",
    imgsource: "cn_tech.jpeg",
    title: "Networking Interview Questions updated on Apr 2020",
    source: "(placement.freshersworld)",
    tag1: "network",
    link: "http://placement.freshersworld.com/networking-interview-questions/33121835176",
  },
  {
    technology: "datastructure",
    imgsource: "ds_tech.jpeg",
    title: "Commonly Asked Data Structure Interview Questions",
    source: "(geeksforgeeks)",
    tag1: "interview-questions",
    link: "https://www.geeksforgeeks.org/commonly-asked-data-structure-interview-questions-set-1/",
  },
  {
    technology: "datastructure",
    imgsource: "ds_tech.jpeg",
    title: "Data Structure Interview Questions",
    source: "(javatpoint)",
    tag1: "beginners",
    tag2: "Interview Questions",
    link: "https://www.javatpoint.com/data-structure-interview-questions",
  },
  {
    technology: "datastructure",
    imgsource: "ds_tech.jpeg",
    title: "20+ Most Asked Data Structures Interview Questions",
    source: "(faceprep)",
    tag1: "Interview Questions",
    tag2: "Answers",
    link: "https://www.faceprep.in/data-structures/data-structures-interview-questions/",
  },
  {
    technology: "datastructure",
    imgsource: "ds_tech.jpeg",
    title: "Top 50 Data Structure Interview Questions & Answers",
    source: "(guru99)",
    tag1: "Data structure",
    tag2: "Questions",
    link: "https://career.guru99.com/top-50-data-structure-interview-questions/",
  },
  {
    technology: "datastructure",
    imgsource: "ds_tech.jpeg",
    title: "DSA Interview Questions",
    source: "(tutorials point)",
    tag1: "algorithms",
    tag2: "structures",
    link: "https://www.tutorialspoint.com/data_structures_algorithms/data_structures_algorithms_interview_questions.htm",
  },
  {
    technology: "datastructure",
    imgsource: "ds_tech.jpeg",
    title: "50+ Data Structure and Algorithms Interview Questions",
    source: "(hackernoon)",
    tag1: "Interview Questions",
    tag2: "Algorithms",
    link: "https://hackernoon.com/50-data-structure-and-algorithms-interview-questions-for-programmers-b4b1ac61f5b0",
  },
  {
    technology: "dbms",
    imgsource: "dbms_tech.jpeg",
    title: "Top 30 DBMS Interview Questions and Answer",
    source: "(softwaretestinghelp.com)",
    tag1: "DBMS",
    tag2: "Interview Questions",
    link: "https://www.softwaretestinghelp.com/top-dbms-interview-questions/",
  },
  {
    technology: "dbms",
    imgsource: "dbms_tech.jpeg",
    title: "Learn DBMS Interview Questions",
    source: "(javatpoint.com)",
    tag1: "DBMS",
    tag2: "Interview",
    link: "https://www.javatpoint.com/dbms-interview-questions",
  },
  {
    technology: "dbms",
    imgsource: "dbms_tech.jpeg",
    title: "Top 50 DBMS Interview Questions and Answers | Edureka",
    source: "(edureka.com)",
    tag1: "DBMS",
    link: "https://www.edureka.co/blog/interview-questions/dbms-interview-questions",
  },
  {
    technology: "dbms",
    imgsource: "dbms_tech.jpeg",
    title: "Top 50 Database(DBMS) Interview Questions & Answers",
    source: "(guru99.com)",
    tag2: "DBMS",
    link: "https://www.guru99.com/database-interview-questions.html",
  },
  {
    technology: "dbms",
    imgsource: "dbms_tech.jpeg",
    title: "Commonly asked DBMS interview questions|Set 1",
    source: "(geeksforgeeks.com)",
    tag2: "DBMS",
    link: "https://www.geeksforgeeks.org/commonly-asked-dbms-interview-questions/",
  },
  {
    technology: "dbms",
    imgsource: "dbms_tech.jpeg",
    title: "DBMS Interview Questions-SQL Advanced - Placement Papers",
    source: "(freshersworld.com)",
    tag2: "DBMS",
    link: "http://placement.freshersworld.com/technical-interview-questions-questions-and-answers/dbms/33111829",
  },
  {
    technology: "dbms",
    imgsource: "dbms_tech.jpeg",
    title: "TOP 250+ DBMS+RDBMS Interview Questions and Answers",
    source: "(wisdomjobs.com)",
    tag2: "DBMS",
    link: "https://www.wisdomjobs.com/e-university/dbms-rdbms-interview-questions.html",
  },
  {
    technology: "html",
    imgsource: "html_tech.jpeg",
    title: "Top 50 HTML Interview Questions and Answers",
    source: "(edureka)",
    tag1: "HTML",
    tag2: "Interview Questions",
    link: "https://www.edureka.co/blog/interview-questions/top-50-html-interview-questions-and-answers/",
  },
  {
    technology: "html",
    imgsource: "html_tech.jpeg",
    title: "30 Top HTML Interview Questions and Answers",
    source: "(softwaretestinghelp)",
    tag1: "HTML",
    tag2: "Interview Questions",
    link: "https://www.softwaretestinghelp.com/html-interview-questions/",
  },
  {
    technology: "html",
    imgsource: "html_tech.jpeg",
    title: "Top 60 HTML & HTML5 Interview Questions & Answers",
    source: "(guru99)",
    tag1: "HTML",
    tag2: "Interview Questions",
    link: "https://career.guru99.com/top-50-html-interview-questions/",
  },
  {
    technology: "html",
    imgsource: "html_tech.jpeg",
    title: "35+ HTML Interview Questions",
    source: "(online interview questions)",
    tag1: "HTML",
    tag2: "Interview Questions",
    link: "https://www.onlineinterviewquestions.com/html-interview-questions/",
  },
  {
    technology: "html",
    imgsource: "html_tech.jpeg",
    title: "Latest HTML interview questions for frontend web developers",
    source: "(techbeamers)",
    tag1: "HTML",
    tag2: "Interview Questions",
    link: "https://www.techbeamers.com/latest-html-interview-questions/",
  },
  {
    technology: "html",
    imgsource: "html_tech.jpeg",
    title: "13 Most Helpful HTML Interview Questions & Best Answers",
    source: "(goskills)",
    tag1: "HTML",
    tag2: "Interview Questions",
    link: "https://www.goskills.com/Development/Articles/HTML-interview-questions-answers",
  },
  {
    technology: "java",
    imgsource: "java_tech.jpeg",
    title: "Real Java Questions & Answers | 300+ Java Interview Questions‎",
    source: "(educative.io)",
    tag1: "Java",
    tag2: "interview questions",
    link: "https://www.googleadservices.com/pagead/aclk?sa=L&ai=DChcSEwi7jpuwxffoAhWElI8KHfEOAXEYABAAGgJzYg&ohost=www.google.com&cid=CAESQOD2ELI1OeVeM2uhRVX4UGBpEzxWiKb36G3q6Iem23yECQXioimoXjuffyTC3t4x3CmYYILHq9GwfX-XvQBpLmE&sig=AOD64_1_refcl7p06Z3vOQe6qkDdn3t-FA&q=&ved=2ahUKEwjQzJSwxffoAhV4zjgGHcS6CPcQ0Qx6BAgQEAE&adurl=",
  },
  {
    technology: "java",
    imgsource: "java_tech.jpeg",
    title: "300 Core Java Interview Questions",
    source: "(javatpoint)",
    tag1: "Java",
    tag2: "interview question",
    link: "https://www.javatpoint.com/corejava-interview-questions",
  },
  {
    technology: "java",
    imgsource: "java_tech.jpeg",
    title: "Java Interview Questions",
    source: "(Tutorialspoint)",
    tag1: "Questions",
    tag2: "Java",
    link: "https://www.tutorialspoint.com/java/java_interview_questions.htm",
  },
  {
    technology: "java",
    imgsource: "java_tech.jpeg",
    title: "100+ Best Core Java Interview Questions & Answers in 2020",
    source: "(hackr.io)",
    tag1: "java",
    tag2: "interview",
    link: "https://hackr.io/blog/java-interview-questions",
  },
  {
    technology: "java",
    imgsource: "java_tech.jpeg",
    title: "Top 50+ Core Java Interview Questions and Answers",
    source: "(software testing help)",
    tag1: "core Java",
    tag2: "Questions",
    link: "https://www.softwaretestinghelp.com/core-java-interview-questions/",
  },
  {
    technology: "java",
    imgsource: "java_tech.jpeg",
    title: "Java Interview Questions",
    source: "(how to do in java)",
    tag1: "Preparation",
    tag2: "Interview",
    link: "https://howtodoinjava.com/java-interview-questions/",
  },
  {
    technology: "javascript",
    imgsource: "js_tech.jpeg",
    title: "Top 50 JavaScript Interview Questions and Answers for 2020",
    source: "(edureka)",
    tag1: "js",
    tag2: "Interview Questions",
    link: "https://www.edureka.co/blog/interview-questions/javascript-interview-questions/",
  },
  {
    technology: "javascript",
    imgsource: "js_tech.jpeg",
    title: "Top 50 JavaScript Interview Questions & Answers",
    source: "(hackr.io)",
    tag1: "javaScript",
    tag2: "Interview Questions",
    link: "https://hackr.io/blog/javascript-interview-questions",
  },
  {
    technology: "javascript",
    imgsource: "js_tech.jpeg",
    title: "37 Essential JavaScript Interview Questions and Answers",
    source: "(toptal)",
    tag1: "js",
    tag2: "Interview Questions",
    link: "https://www.toptal.com/javascript/interview-questions",
  },
  {
    technology: "javascript",
    imgsource: "js_tech.jpeg",
    title: "JavaScript Interview Questions",
    source: "(javatpoint)",
    tag1: "javaScript",
    tag2: "Interview Questions",
    link: "https://www.javatpoint.com/javascript-interview-questions",
  },
  {
    technology: "javascript",
    imgsource: "js_tech.jpeg",
    title: "70 JavaScript Interview Questions",
    source: "(dev.to)",
    tag1: "js",
    tag2: "Interview Questions",
    link: "https://dev.to/macmacky/70-javascript-interview-questions-5gfi",
  },
  {
    technology: "javascript",
    imgsource: "js_tech.jpeg",
    title: "Javascript Interview Questions",
    source: "(tutorialspoint)",
    tag1: "javaScript",
    tag2: "Interview Questions",
    link: "https://www.tutorialspoint.com/javascript/javascript_interview_questions.htm",
  },
  {
    imgsource: "oops_tech.jpeg",
    title: "OOPs Interview Questions",
    source: "(edureka)",
    tag1: "OOPs",
    tag2: "Interview Questions",
    link: "https://www.edureka.co/blog/interview-questions/oops-interview-questions/",
    technology: "oops",
  },
  {
    imgsource: "oops_tech.jpeg",
    title: "Commonly Asked OOP Interview Questions",
    source: "(geeksforgeeks)",
    tag1: "Common",
    tag2: "OOP",
    link: "https://www.geeksforgeeks.org/commonly-asked-oop-interview-questions/",
    technology: "oops",
  },
  {
    imgsource: "oops_tech.jpeg",
    title: "Top 20+ OOPS Interview Questions and Answers in 2020",
    source: "(best interview question)",
    tag1: "oops interview",
    tag2: "answers",
    link: "https://www.bestinterviewquestion.com/oops-interview-questions",
    technology: "oops",
  },
  {
    imgsource: "oops_tech.jpeg",
    title: "TOP 250+ OOPS Interview Questions and Answer",
    source: "(wisdom jobs)",
    tag1: "OOPS",
    tag2: "Interview Questions",
    link: "https://www.wisdomjobs.com/e-university/oops-interview-questions.html",
    technology: "oops",
  },
  {
    imgsource: "oops_tech.jpeg",
    title: "Top 30 OOPs Interview Questions",
    source: "(spring people)",
    tag1: "Top 30",
    tag2: "OOP",
    link: "https://www.springpeople.com/blog/30-oops-interview-questions-and-answers-2018/",
    technology: "oops",
  },
  {
    imgsource: "os_tech.jpeg",
    title: "Commonly Asked Operating Systems Interview Questions",
    source: "(OS)",
    tag1: "interview-questions",
    link: "https://www.geeksforgeeks.org/commonly-asked-operating-systems-interview-questions-set-1/",
    technology: "os",
  },
  {
    imgsource: "os_tech.jpeg",
    title: "90 Operating System Interview Questions and Answers",
    source: "(careerride)",
    tag1: "interview-questions",
    link: "https://www.careerride.com/Operating-System-Interview-Questions.aspx",
    technology: "os",
  },
  {
    imgsource: "os_tech.jpeg",
    title: "Top 10 OS Interview Questions and Answers {Updated for 2020}",
    source: "(os)",
    tag1: "interview-questions",
    link: "https://www.educba.com/os-interview-questions/",
    technology: "os",
  },
  {
    imgsource: "os_tech.jpeg",
    title: "Operating Systems - Interview Questions and Answers",
    source: "(indiabix)",
    tag1: "interview-questions",
    link: "https://www.indiabix.com/technical/operating-systems/",
    technology: "os",
  },
  {
    imgsource: "os_tech.jpeg",
    title: "Top 40 Operating System Interview Questions & Answers",
    source: "(techgeekbuzz)",
    tag1: "interview-questions",
    link: "http://www.techgeekbuzz.com/os-interview-questions/",
    technology: "os",
  },
  {
    imgsource: "os_tech.jpeg",
    title: "OS Exams Questions with Answers",
    source: "(tutorials point)",
    tag1: "interview-questions",
    link: "https://www.tutorialspoint.com/operating_system/os_exams_questions_answers.htm",
    technology: "os",
  },
  {
    imgsource: "python_tech.jpeg",
    title: "Python Interview Questions and Answers (2020)",
    source: "(interview bit)",
    tag1: "interview",
    tag2: "python",
    link: "https://www.interviewbit.com/python-interview-questions/",
    technology: "python",
  },
  {
    imgsource: "python_tech.jpeg",
    title: "Top 100 Python Interview Questions & Answers For 2020 ...",
    source: "(edureka)",
    tag1: "Python",
    tag2: "Interview Questions",
    link: "https://www.edureka.co/blog/interview-questions/python-interview-questions/",
    technology: "python",
  },
  {
    imgsource: "python_tech.jpeg",
    title: "150+ Python Interview Questions and Answers for Freshers",
    source: "(data-flair.training)",
    tag1: "Interview",
    tag2: "Python",
    link: "https://data-flair.training/blogs/top-python-interview-questions-answer/",
    technology: "python",
  },
  {
    imgsource: "python_tech.jpeg",
    title: "Top 50+ Python Interview Questions",
    source: "(javatpoint)",
    tag1: "Python",
    tag2: "interview questions",
    link: "https://www.javatpoint.com/python-interview-questions",
    technology: "python",
  },
  {
    imgsource: "python_tech.jpeg",
    title: "53 Python Interview Questions and Answers",
    source: "(towards datascience)",
    tag1: "interview",
    tag2: "python",
    link: "https://towardsdatascience.com/53-python-interview-questions-and-answers-91fa311eec3f",
    technology: "python",
  },
  {
    imgsource: "python_tech.jpeg",
    title: "50 Top Python Interview Questions & Answers",
    source: "(hackr.io)",
    tag1: "latest",
    tag2: "Questions",
    link: "https://hackr.io/blog/python-interview-questions",
    technology: "python",
  },
  {
    imgsource: "rdbms_tech.jpeg",
    title: "Top 15+ rdbms interview questions and answers in 2020",
    source: "(bestinterviewquestion)",
    tag1: "rdbms",
    tag2: "interview",
    link: "https://www.bestinterviewquestion.com/rdbms-interview-questions",
    technology: "rdbms",
  },
  {
    imgsource: "rdbms_tech.jpeg",
    title: "TOP 250+ RDBMS Interview Questions and Answers",
    source: "(wisdomjobs)",
    tag1: "Interview",
    tag2: "RDBMS",
    link: "https://www.wisdomjobs.com/e-university/rdbms-interview-questions.html",
    technology: "rdbms",
  },
  {
    imgsource: "rdbms_tech.jpeg",
    title: "Commonly asked RDBMS interview questions",
    source: "(geeksforgeeks)",
    tag1: "questions",
    tag2: "RDBMS",
    link: "https://www.geeksforgeeks.org/commonly-asked-dbms-interview-questions/",
    technology: "rdbms",
  },
  {
    imgsource: "rdbms_tech.jpeg",
    title: "RDBMS Interview Questions and Answers 2019 [UPDATED]",
    source: "(mytectra)",
    tag1: "interview",
    tag2: "RDBMS",
    link: "https://www.mytectra.com/interview-question/rdbms-interview-questions-and-answers-2019/",
    technology: "rdbms",
  },
  {
    imgsource: "rdbms_tech.jpeg",
    title: "RDBMS Interview Questions and Answers for Freshers",
    source: "(sanfoundry)",
    tag1: "Freshers",
    tag2: "interview-questions",
    link: "https://www.sanfoundry.com/rdbms-interview-questions-answers-freshers/",
    technology: "rdbms",
  },
  {
    imgsource: "rdbms_tech.jpeg",
    title: "RDBMS Questions and Answers",
    source: "(allindiaexams)",
    tag1: "RDBMS",
    tag2: "Questions",
    link: "http://www.allindiaexams.in/engineering/cse/dbms-multiple-choice-questions-and-answers/rdbms",
    technology: "rdbms",
  },
  {
    imgsource: "react_tech.jpeg",
    title: "React Interview Questions & Answers",
    source: "(hackr.io)",
    tag1: "react",
    tag2: "Interview Questions",
    link: "https://hackr.io/blog/react-interview-questions",
    technology: "React",
  },
  {
    imgsource: "react_tech.jpeg",
    title: "21 Essential React.js Interview Questions and Answers",
    source: "(toptal)",
    tag1: "react",
    tag2: "Interview Questions",
    link: "https://www.toptal.com/react/interview-questions",
    technology: "React",
  },
  {
    imgsource: "react_tech.jpeg",
    title: "39+ Advanced React Interview Questions (SOLVED)",
    source: "(fullstack.cafe)",
    tag1: "react",
    tag2: "Interview Questions",
    link: "https://www.fullstack.cafe/blog/react-js-interview-questions",
    technology: "React",
  },
  {
    imgsource: "react_tech.jpeg",
    title: "Top 50 React JS Interview Questions",
    source: "(mindmajix.com)",
    tag1: "react",
    tag2: "Interview Questions",
    link: "https://mindmajix.com/reactjs-interview-questions",
    technology: "React",
  },
  {
    imgsource: "react_tech.jpeg",
    title: "React Interview Questions",
    source: "(tylermcginnis.com)",
    tag1: "react",
    tag2: "Interview Questions",
    link: "https://tylermcginnis.com/react-interview-questions/",
    technology: "React",
  },
  {
    imgsource: "react_tech.jpeg",
    title: "Frequently asked: React JS Interview Questions and Answers",
    source: "(medium.com)",
    tag1: "react",
    tag2: "Interview Questions",
    link: "https://medium.com/@vigowebs/frequently-asked-react-js-interview-questions-and-answers-36f3dd99f486",
    technology: "React",
  },

  {
    imgsource: "sdlc_tech.jpeg",
    title: "Read Best SDLC Interview Questions in 2020",
    source: "(online interview questions)",
    tag1: "SDLC",
    tag2: "Interview Questions",
    link: "https://www.onlineinterviewquestions.com/sdlc-interview-questions/",
    technology: "sdlc",
  },
  {
    imgsource: "sdlc_tech.jpeg",
    title: "Software Engineering Interview Questions",
    source: "(tutorialspoint)",
    tag1: "SDLC",
    tag2: "Interview Questions",
    link: "https://www.tutorialspoint.com/software_engineering/pdf/software_engineering_interview_questions.pdf",
    technology: "sdlc",
  },
  {
    imgsource: "sdlc_tech.jpeg",
    title: "SDLC Interview Questions with Answers",
    source: "(complex sql)",
    tag1: "SDLC",
    tag2: "Interview Questions",
    link: "https://www.complexsql.com/sdlc-interview-questions/",
    technology: "sdlc",
  },
  {
    imgsource: "sdlc_tech.jpeg",
    title: "SDLC Interview Questions and Answers",
    source: "(gcreddy)",
    tag1: "SDLC",
    tag2: "Interview Questions",
    link: "https://www.gcreddy.com/2014/06/sdlc-interview-questions.html",
    technology: "sdlc",
  },
  {
    imgsource: "sdlc_tech.jpeg",
    title: "SDLC Interview Questions and Answers",
    source: "(stechies)",
    tag1: "SDLC",
    tag2: "Interview Questions",
    link: "https://www.stechies.com/sdlc-interview-questions/",
    technology: "sdlc",
  },
  {
    imgsource: "sdlc_tech.jpeg",
    title: "SDLC Interview Questions and Answers",
    source: "(withoutbook)",
    tag1: "SDLC",
    tag2: "Interview Questions",
    link: "http://www.withoutbook.com/Technology.php?tech=61&subject=sdlc%20Interview%20Questions%20and%20Answers",
    technology: "SDLC",
  },
  {
    imgsource: "sql_tech.jpeg",
    title: "SQL Interview Questions",
    source: "(javatpoint)",
    tag1: "sql",
    tag2: "Interview Questions",
    link: "https://www.javatpoint.com/sql-interview-questions",
    technology: "sql",
  },
  {
    imgsource: "sql_tech.jpeg",
    title: "50+ Top SQL Interview Questions & Answers in 2020",
    source: "(hackr.io)",
    tag1: "sql",
    tag2: "Interview Questions",
    link: "https://hackr.io/blog/top-sql-interview-questions",
    technology: "sql",
  },
  {
    imgsource: "sql_tech.jpeg",
    title: "SQL Interview Questions",
    source: "(geeksforgeeks)",
    tag1: "sql",
    tag2: "Interview Questions",
    link: "https://www.geeksforgeeks.org/sql-interview-questions/",
    technology: "sql",
  },
  {
    imgsource: "sql_tech.jpeg",
    title: "Top 90 SQL Interview Questions and Answers (LATEST)",
    source: "(softwaretestinghelp)",
    tag1: "sql",
    tag2: "Interview Questions",
    link: "https://www.softwaretestinghelp.com/50-popular-sql-interview-questions-for-testers/",
    technology: "sql",
  },
  {
    imgsource: "sql_tech.jpeg",
    title: "Top 90 SQL Interview Questions And Answers",
    source: "(mindmajix)",
    tag1: "sql",
    tag2: "Interview Questions",
    link: "https://mindmajix.com/sql-interview-questions",
    technology: "sql",
  },
  {
    imgsource: "ds_tech.jpeg",
    title: "Top 50 Manual Testing Interview Questions and Answers",
    source: "(edureka)",
    tag1: "Testing",
    tag2: "Interview Questions",
    link: "https://www.edureka.co/blog/interview-questions/manual-testing-interview-questions/",
    technology: "testing",
  },
  {
    imgsource: "ds_tech.jpeg",
    title: "Top 25 Functional Testing Interview Question and Answers",
    source: "(softwaretestinghelp)",
    tag1: "Testing",
    tag2: "Interview Questions",
    link: "https://www.softwaretestinghelp.com/functional-testing-interview-questions/",
    technology: "testing",
  },
  {
    imgsource: "ds_tech.jpeg",
    title: "Top 200 Software Testing Interview Questions",
    source: "(softwaretestinghelp)",
    tag1: "Testing",
    tag2: "Interview Questions",
    link: "https://www.softwaretestinghelp.com/software-testing-interview-questions/",
    technology: "testing",
  },
  {
    imgsource: "ds_tech.jpeg",
    title: "40 Top Manual Testing Interview Questions & Answers",
    source: "(hackr.io)",
    tag1: "Testing",
    tag2: "Interview Questions",
    link: "https://hackr.io/blog/manual-testing-interview-questions",
    technology: "testing",
  },
  {
    imgsource: "ds_tech.jpeg",
    title: "Manual Testing Interview Question",
    source: "(techbeamers)",
    tag1: "Testing",
    tag2: "Interview Questions",
    link: "https://www.techbeamers.com/manual-testing-interview-questions-experienced-qa/",
    technology: "testing",
  },
  {
    imgsource: "ds_tech.jpeg",
    title: "100+ Manual Testing Interview Questions",
    source: "(artoftesting)",
    tag1: "Testing",
    tag2: "Interview Questions",
    link: "https://artoftesting.com/manual-testing-interview-questions",
    technology: "testing",
  },
];
